﻿/**
 * Italian locale messages
 * Mirrors the structure of the English source of truth
 */

import { brand } from '../config/brand';

export default {
  // Controlli e finestra meteo (CurrentWeather, WeatherModal, WeatherForecast)
  weather: {
    title: 'Meteo attuale',
    refresh: 'Aggiorna il meteo',
    updated: 'Aggiornato',
    justNow: 'adesso',
    feelsLike: 'Percepita',
    humidity: 'Umidità',
    wind: 'Vento',
    pressure: 'Pressione',
    clouds: 'Nuvole',
    visibility: 'Visibilità',
    sunrise: 'Alba',
    sunset: 'Tramonto',
    hourlyForecast: 'Previsioni orarie',
    dailyForecast: 'Previsioni giornaliere',
    forecastTitle: 'Previsioni meteo',
    hourly: 'Orario',
    daily: 'Giornaliero',
    today: 'Oggi',
    tomorrow: 'Domani',
    unavailable: 'I dati meteo non sono ancora disponibili.',
    forecastUnavailable: 'Previsioni non disponibili.',
    rainPercent: '{count}% di pioggia',
    noRain: 'Nessuna pioggia',
    configureInSettings: 'Configura il meteo nelle impostazioni',
    loadFailed: 'Impossibile caricare i dati meteo',
    alertsTitle: 'Avvisi meteo',
    now: 'Adesso',
    scrub: 'Scorri le previsioni',
    sun: 'Sole',
    moon: 'Luna',
    moonrise: 'Sorgere della luna',
    moonset: 'Tramonto della luna',
    illumination: 'illuminata',
    details: 'Dettagli',
  },
  // Aggiunta stanze (AddRoomModal) - testi dell'interfaccia
  roomWizard: {
    addRooms: 'Aggiungi stanze',
    buildingType: 'Tipo di edificio',
    selectDefaults: 'Seleziona le stanze predefinite per {type}',
    selectCommonRooms: 'Seleziona stanze comuni',
    alreadyExists: 'Esiste già',
    floor: 'Piano {number}',
    addCustomRoom: 'Aggiungi stanza personalizzata',
    roomName: 'Nome stanza',
    roomNamePlaceholder: 'es. Camera per ospiti, Cantina vini',
    floorNumber: 'Numero piano',
    floorNumberPlaceholder: '0, 1, 2...',
    addCustomRoomButton: 'Aggiungi stanza personalizzata alla selezione',
    areaAssignment: 'Assegnazione area (facoltativa)',
    assignToArea: 'Assegna all’area',
    noArea: 'Nessuna area',
    areaHelp: 'Tutte le stanze selezionate verranno assegnate a questa area',
    selectedRooms: 'Stanze selezionate ({count})',
    clearAll: 'Cancella tutto',
    cancel: 'Annulla',
    creating: 'Creazione...',
    createOne: 'Crea {count} stanza',
    createMany: 'Crea {count} stanze',
    searchIcons: 'Cerca icone',
  },
  // Aggiunta stanze - tipi di edificio e stanze comuni
  roomPresets: {
    buildingTypes: {
      allRooms: 'Tutte le stanze',
      home: 'Abitazione',
      house: 'Casa',
      office: 'Ufficio',
      school: 'Scuola',
      hotel: 'Hotel',
      hospital: 'Ospedale',
    },
    rooms: {
      entrance_hall: 'Ingresso',
      living_room: 'Soggiorno',
      dining_room: 'Sala da pranzo',
      kitchen: 'Cucina',
      pantry: 'Dispensa',
      family_room: 'Salotto',
      study: 'Studio',
      home_office: 'Ufficio in casa',
      library: 'Biblioteca',
      master_bedroom: 'Camera principale',
      bedroom: 'Camera da letto',
      bedroom_2: 'Camera da letto 2',
      bedroom_3: 'Camera da letto 3',
      bedroom_4: 'Camera da letto 4',
      guest_bedroom: 'Camera per ospiti',
      kids_room: 'Camera dei bambini',
      master_bathroom: 'Bagno principale',
      bathroom: 'Bagno',
      powder_room: 'Bagno di servizio',
      laundry: 'Lavanderia',
      garage: 'Garage',
      workshop: 'Officina',
      storage: 'Magazzino',
      utility_room: 'Ripostiglio',
      basement: 'Seminterrato',
      wine_cellar: 'Cantina vini',
      home_theater: 'Home theater',
      game_room: 'Sala giochi',
      gym: 'Sala fitness',
      patio: 'Patio',
      balcony: 'Balcone',
      terrace: 'Terrazza',
      garden: 'Giardino',
      pool_area: 'Area piscina',
      hallway: 'Corridoio',
      attic: 'Soffitta',
      reception: 'Reception',
      office: 'Ufficio',
      meeting_room: 'Sala riunioni',
      conference_room: 'Sala conferenze',
      break_room: 'Sala relax',
      restroom: 'Toilette',
      server_room: 'Sala server',
      classroom: 'Aula',
      cafeteria: 'Mensa',
      gymnasium: 'Palestra',
      laboratory: 'Laboratorio',
      playground: 'Parco giochi',
      lobby: 'Hall',
      guest_room: 'Camera ospiti',
      suite: 'Suite',
      restaurant: 'Ristorante',
    },
  },
  // Common UI elements - buttons, actions, generic labels
  common: {
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    remove: 'Rimuovi',
    close: 'Chiudi',
    back: 'Indietro',
    confirm: 'Conferma',
    ok: 'OK',
    loading: 'Caricamento...',
    saving: 'Salvataggio...',
    error: 'Errore',
    more: 'Più',
    copy: 'Copia',
    all: 'Tutti',
    language: 'Lingua',
    password: 'Password',
  },

  // Stringhe di dialogo / finestre di messaggio (conferma, avviso, toast)
  dialogs: {
    // Generiche
    areYouSure: 'Sei sicuro?',
    typeDelete: 'Digita "DELETE"',
    finalWarning: 'AVVISO FINALE. Tutti i dati verranno eliminati. Continuare?',
    done: 'Fatto',
    errorWithMessage: 'Errore: {message}',
    saveFailed: 'Impossibile salvare le modifiche',
    validationErrors: 'Correggi i seguenti errori:\n{errors}',
    deleteAllConversationHistory:
      'Vuoi davvero eliminare tutta la cronologia della conversazione? Questa azione non può essere annullata.',
    unregisterFromCloud: "Annullare la registrazione dal cloud? L'accesso remoto verrà disattivato.",
    removeUserAccess: "Rimuovere l'accesso di questo utente?",
    allDevicesDeleted: 'Tutti i dispositivi eliminati',
    allRoomsDeleted: 'Tutte le stanze eliminate',
    allIntegrationsDeleted: 'Tutte le integrazioni eliminate',
    allScenesDeleted: 'Tutte le scene eliminate',
    factoryResetInitiated: 'Ripristino alle impostazioni di fabbrica avviato.',
    // Dispositivo
    deviceDeleteConfirm: 'Vuoi davvero eliminare "{name}"?\n\nQuesta azione non può essere annullata.',
    deviceDeleteConfirmShort: 'Vuoi davvero eliminare questo dispositivo?',
    deviceRemoveConfirm: 'Vuoi davvero rimuovere questo dispositivo?',
    deviceDeleteFailed: 'Impossibile eliminare il dispositivo',
    devicesDeleteFailed: 'Impossibile eliminare i dispositivi',
    deviceDeleteFailedMessage: 'Impossibile eliminare il dispositivo: {message}',
    deviceDuplicateFailed: 'Impossibile duplicare il dispositivo: {message}',
    deviceReorderFailed: "Impossibile aggiornare l'ordine dei dispositivi",
    deviceReinitConfirm:
      "Questo eliminerà e ricreerà tutti i valori del dispositivo in base alla definizione del tipo di dispositivo. I valori creati dall'utente verranno conservati. I riferimenti (indirizzi KNX, mapping Matter) andranno persi e dovranno essere riconfigurati. Continuare?",
    deviceReinitFailed: 'Impossibile reinizializzare i valori del dispositivo',
    deviceRefsSaveFailed: 'Impossibile salvare i riferimenti',
    deviceRefsUpdateFailed: 'Alcuni riferimenti non sono stati aggiornati:\n{errors}',
    customValueDeleteConfirm: 'Eliminare il valore personalizzato "{name}"?',
    thumbnailUploadFailed: 'Caricamento della miniatura del dispositivo non riuscito: {message}',
    thumbnailRemoveFailed: 'Eliminazione della miniatura del dispositivo non riuscita: {message}',
    stateThumbnailUploadFailed: 'Caricamento immagine di stato non riuscito: {message}',
    stateThumbnailRemoveFailed: 'Eliminazione immagine di stato non riuscita: {message}',
    deviceRoomUpdateFailed: 'Impossibile aggiornare la stanza: {message}',
    // Widget / dashboard
    widgetDeleteConfirm: 'Vuoi davvero eliminare questo widget?',
    widgetMissing: "Questo widget non esiste più. Potrebbe essere stato rimosso. L'elenco dei widget verrà aggiornato.",
    widgetSaveFailed: 'Salvataggio non riuscito: {message}',
    widgetRemoveConfirm: 'Rimuovere questo widget dalla dashboard?',
    dashboardRebuildConfirm:
      'Ricostruire "{name}" come {label}? I widget esistenti di questa pagina verranno sostituiti.',
    dashboardDeleteConfirm: 'Eliminare "{name}"? Questa azione non può essere annullata.',
    dashboardGroupDeleteConfirm: 'Eliminare il gruppo "{name}"? Le pagine di questo gruppo verranno separate.',
    dashboardGroupDeleteCountConfirm: 'Eliminare il gruppo "{name}"? {count} pagina/e verranno separate.',
    // Stanza
    roomExistsInDb: 'La stanza "{name}" esiste già nel database.',
    roomAlreadyInSelection: 'La stanza "{name}" è già nella tua selezione.',
    roomsCreateFailed: 'Impossibile creare le stanze',
    roomUpdateFailed: 'Impossibile aggiornare la stanza',
    // Scena
    sceneCreateFailed: 'Impossibile creare la scena',
    sceneDeleteFailed: 'Impossibile eliminare la scena',
    sceneValuesSaveFailed: 'Impossibile salvare i valori della scena',
    sceneThumbnailUploadFailed: 'Caricamento miniatura non riuscito',
    // Automazione
    automationCreateFailed: 'Impossibile creare la funzione',
    automationSaveFailed: 'Impossibile salvare la funzione',
    automationDeleteConfirm: 'Vuoi davvero eliminare "{name}"?',
    automationDeleteFailed: 'Impossibile eliminare la funzione',
    automationDeleteFailedRetry: 'Impossibile eliminare la funzione. Riprova.',
    // Calendario
    calendarDeleteConfirm: 'Eliminare "{name}" e tutti i suoi eventi?',
    calendarSaveChanges: 'Vuoi salvare le modifiche?',
    calendarDiscardChanges: 'Annullare le modifiche non salvate?',
    calendarDeleteEvent: 'Eliminare "{title}"?',
    // Fotocamera / integrazione
    cameraDeleteRecording: 'Eliminare questa registrazione? Tutti i segmenti verranno rimossi definitivamente.',
    cameraDeleteRecordingEvent:
      'Eliminare questo evento di registrazione? Tutti i segmenti verranno eliminati definitivamente.',
    cameraDeleteConfirm: 'Eliminare la fotocamera "{name}"? Tutte le registrazioni verranno eliminate definitivamente.',
    cameraDeleteAllRecordings: 'Eliminare TUTTE le registrazioni di "{name}"? Questa azione non può essere annullata.',
    cameraResetSettings: 'Reimpostare tutte le impostazioni di streaming ai valori predefiniti?',
    cameraToggleFailed: "Impossibile attivare/disattivare l'integrazione: {message}",
    cameraNameSaveFailed: 'Impossibile salvare il nome: {message}',
    cameraSettingsSaved: 'Impostazioni fotocamera salvate con successo',
    cameraSettingsSaveFailed: 'Impossibile salvare le impostazioni della fotocamera: {message}',
    integrationConfigSaveFailed: 'Impossibile salvare la configurazione: {message}',
    knxNoInterfaces:
      "Nessuna interfaccia IP KNX trovata sulla rete. Assicurati che l'interfaccia IP KNX sia accesa e collegata.",
    discoveryFailed: 'Rilevamento non riuscito: {message}',
    devicesAddFailed: 'Impossibile aggiungere alcuni dispositivi: {message}',
    // Galleria / immagini
    imageDeleteConfirm: 'Vuoi davvero eliminare questa immagine?',
    imageDeleteForEntity: "Eliminare l'immagine di tipo {type} per {entity}?",
    imageReplaceForEntity: "Sostituire l'immagine di tipo {type} per {entity}?",
    fileTooLarge: 'Il file è troppo grande (max 50 MB)',
    fileDeleteConfirm: 'Eliminare "{name}"?',
    fileDeleteFailed: 'Eliminazione non riuscita',
    albumAddFailed: "Impossibile aggiungere all'album",
    albumRemoveFailed: "Impossibile rimuovere dall'album",
    albumSaveFailed: "Impossibile salvare l'album",
    albumDeleteConfirm: 'Eliminare l\'album "{name}"? Le foto non verranno eliminate.',
    albumDeleteFailed: "Impossibile eliminare l'album",
    // Media / note
    mediaDeleteConfirm: 'Eliminare "{title}" dalla libreria multimediale? Questo rimuove anche il file dal server.',
    playlistDeleteConfirm: 'Eliminare questa playlist?',
    zoneDeleteConfirm: 'Eliminare questa zona? La riproduzione verrà interrotta e tutti i membri verranno rimossi.',
    mediaPlayerRemoveConfirm: 'Rimuovere questo lettore multimediale?',
    coverPhotoUploadFailed: 'Caricamento foto di copertina non riuscito',
    coverPhotoRemoveConfirm: 'Rimuovere questa foto di copertina?',
    coverPhotoRemoveFailed: 'Impossibile rimuovere la foto di copertina',
    noteSaveFailed: 'Impossibile salvare la nota',
    noteDeleteConfirm: 'Eliminare questa nota e tutte le sue immagini?',
    noteDeleteFailed: 'Impossibile eliminare la nota',
    // Agente
    agentClearConversation: 'Cancellare questa conversazione?',
    logoutConfirm: 'Vuoi davvero uscire?',
    reminderDeleteConfirm: 'Eliminare questo promemoria?',
    // Shopping
    shoppingListSaveFailed: 'Impossibile salvare la lista',
    shoppingListDeleteConfirm: 'Eliminare questa lista e tutti i suoi articoli?',
    shoppingListDeleteFailed: 'Impossibile eliminare la lista',
    shoppingItemAddFailed: "Impossibile aggiungere l'articolo",
    shoppingClearCheckedConfirm: 'Rimuovere tutti gli articoli selezionati?',
    shoppingClearFailed: 'Impossibile svuotare gli articoli',
    shoppingStoreAddFailed: 'Impossibile aggiungere il negozio',
    shoppingStoreDeleteConfirm:
      "Eliminare questo negozio? Le liste rimarranno ma perderanno l'associazione al negozio.",
    shoppingStoreDeleteFailed: 'Impossibile eliminare il negozio',
    // Integrazione (Matter / Z-Wave / Zigbee / monitoraggio)
    monitoringStartFailed: 'Impossibile avviare il monitoraggio: {message}',
    monitorWriteFailed: 'Scrittura non riuscita: {message}',
    monitorReadFailed: 'Lettura non riuscita: {message}',
    mqttPropertyDeleteConfirm:
      'Eliminare questa proprietà MQTT? I riferimenti ai dispositivi esistenti verranno rimossi.',
    modbusRegisterDeleteConfirm:
      'Eliminare questo registro Modbus? I riferimenti ai dispositivi esistenti verranno rimossi.',
    knxDatapointDeleteConfirm:
      'Eliminare questo indirizzo di gruppo KNX? I riferimenti ai dispositivi esistenti verranno rimossi.',
    commissioningWindowFailed: 'Impossibile aprire la finestra di commissioning',
    matterDeviceUpdateFailed: 'Impossibile aggiornare il dispositivo',
    matterDeviceSaveFailed: 'Impossibile salvare il dispositivo',
    matterDeleteFailed: 'Eliminazione non riuscita',
    matterError: '❌ Errore: {message}',
    matterReinterviewConfirm:
      'Re-intervistare il nodo {id}? Questo eliminerà e ricreerà tutti i dispositivi di questo nodo.',
    matterDecommissioned: '✅ Nodo Matter rimosso ed eliminato con successo',
    matterNodeDeleteError: "❌ Errore durante l'eliminazione del nodo: {message}",
    matterNodeRemoveTitle: 'Rimuovi nodo Matter',
    matterNodeRemoveInspecting: 'Ispezione del nodo…',
    matterNodeRemoveDecommission: 'Il controller ha ancora questo nodo: prima verrà rimosso dalla rete, poi saranno eliminate le sue righe.',
    matterNodeRemoveGhost: 'Il controller non ha questo nodo (la memoria è stata azzerata o il nodo appartiene a un altro fabric). Le sue righe saranno eliminate senza contattare il controller.',
    matterNodeRemovePruneCounts: 'Righe da rimuovere: {endpoints} endpoint, {clusters} cluster, {properties} righe di attributi.',
    matterNodeRemoveControllerOffline: 'Il controller Matter non è in esecuzione, quindi non è possibile scegliere tra rimozione dalla rete e pulizia. Avvia prima questa integrazione: l\'hub rifiuta di eliminare righe che non può verificare.',
    matterNodeRemoveDevicesFlag: 'Elimina anche i {count} dispositivi creati da questo nodo (elencati sotto)',
    matterNodeRemoveDetach: '{count} dispositivo/i di un\'altra integrazione verranno solo scollegati da questo nodo, non eliminati.',
    matterNodeRemoveOtherIntegration: 'altra integrazione',
    matterNodeRemoveConfirm: 'Rimuovi nodo',
    matterNodeRemoving: 'Rimozione…',
    matterNodeRemoved: '✅ Nodo rimosso — {endpoints} endpoint, {clusters} cluster, {properties} righe di attributi, {devices} dispositivo/i.',
    matterNodeGhostHint: 'Non presente nel controller Matter: questo nodo non potrà mai essere comandato.',
    matterNodeRemoveAction: 'Rimuovi',
    matterDiagnosticsFailed: 'Impossibile ottenere la diagnostica: {message}',
    matterFabricResetConfirm:
      '⚠️ Reimpostare il fabric Matter?\n\nQuesto:\n- Eliminerà tutto lo storage e le credenziali Matter\n- Genererà un nuovo ID fabric\n- Rimuoverà tutti i dispositivi commissionati\n- Richiederà il re-commissioning di tutti i dispositivi\n\nQuesta azione NON può essere annullata. Continuare?',
    matterFabricResetSuccess:
      '✅ Reset del fabric riuscito!\n\nIl controller Matter si riavvierà con un nuovo ID fabric.\nAggiorna la pagina tra qualche secondo.',
    matterFabricResetFailed: '❌ Reset del fabric non riuscito: {message}',
    factoryResetFailed: 'Reset di fabbrica non riuscito',
    matterDeviceRemoveFailed: 'Impossibile rimuovere il dispositivo',
    threadSaveFailed:
      "Impossibile salvare il dataset Thread. La funzionalità potrebbe non essere ancora implementata sull'hub.",
    zigbeeGroupDeleteConfirm: 'Eliminare il gruppo {id}?',
    remoteSupportEndSessionFailed: 'Impossibile terminare la sessione',
    remoteSupportSendMessageFailed: 'Impossibile inviare il messaggio',
    zigbeeNodeRemoveConfirm: 'Rimuovere il nodo {id}?',
    zwaveNodeRemoveConfirm: 'Rimuovere il nodo {id} dal database?',
    zwaveNodeRenameFailed: 'Impossibile rinominare il nodo',
    zwaveEndpointRenameFailed: "Impossibile rinominare l'endpoint",
    wifiSaveFailed:
      "Impossibile salvare le credenziali WiFi. La funzionalità potrebbe non essere ancora implementata sull'hub.",
    touchPanelUnpairConfirm: 'Scollegare "{name}"? Il dispositivo dovrà essere riassociato.',
    mapZoneDeleteConfirm: 'Eliminare la zona "{name}"?',
    securityPinRemoveConfirm:
      'Rimuovere il PIN dei dispositivi segreti? Le fotocamere segrete saranno accessibili senza PIN.',
    // Impostazioni
    scheduleEditorComingSoon:
      "L'editor di programmi arriverà presto. Configura i programmi dei dispositivi tramite API o pagina Energia.",
    libraryDeleteConfirm: 'Eliminare questo elemento?',
    securityModeDeleteConfirm: 'Eliminare questa modalità di sicurezza? Questa azione non può essere annullata.',
    remoteSupportRemoveUserFailed: "Impossibile rimuovere l'utente",
    remoteSupportUpdateAccessFailed: "Impossibile aggiornare l'accesso",
    // Utente
    userSaveFailed: "Impossibile salvare l'utente",
    userDeleteFailed: "Impossibile eliminare l'utente: {message}",
    profilePictureRemoveConfirm: 'Vuoi davvero rimuovere la tua foto profilo?',
    // Server
    serverRemoveFromCloud: `Rimuovere "{hub}" da ${brand.agentName} Cloud?\n\nAvvertenze:\n- Le voci di accesso condiviso di questo server verranno eliminate.\n- Il server ${brand.agentName} locale continuerà a funzionare.\n- Per ricomparire nel cloud, il server deve riconnettersi e registrarsi di nuovo.\n\nQuesta azione non può essere annullata.`,
    // Editor
    imageUrlMissing: "Caricamento riuscito ma non è stata restituita alcuna URL dell'immagine.",
    imageUploadFailed: 'Caricamento immagine non riuscito',
  },

  // Authentication
  auth: {
    signIn: 'Accedi',
    emailAddress: 'Indirizzo email',
    passwordPlaceholder: 'Inserisci la tua password',
    signInToYourHub: 'Accedi al tuo hub',
    signInToOttoHome: `Accedi a ${brand.platformCompact}`,
    signingIn: 'Accesso in corso...',
    invalidCredentials: 'Email o password non validi',
    // No "Forgot password?" link on the sign-in form: the hub serves no
    // forgot/reset route any more (PLAN.md §4 phase 4, hub commit 51677c7),
    // so this sentence is the whole answer the form can honestly give.
    noPasswordReset:
      "Nessun ripristino della password: questo hub concede l'accesso tramite invito, non via email. Chiedi a un amministratore di invitarti o collega questo dispositivo dall'app.",
    genericError: 'Si è verificato un errore. Riprova.',
    secureSmartHome: 'Accesso sicuro alla tua casa intelligente',
    usernameOrEmail: 'Nome utente o email',
    setupWizardTitle: 'Configura il tuo hub',
    setupWelcome: 'Benvenuto! Prepareremo il tuo hub in pochi passaggi.',
    setupStepSettingsTitle: 'Impostazioni di sistema',
    setupStepSettingsDesc: "Dai un nome e un'immagine al tuo hub per riconoscerlo facilmente.",
    setupStepCloudTitle: 'Registrati con il cloud (facoltativo)',
    setupStepCloudDesc:
      'La registrazione consente email, notifiche push e accesso remoto. I servizi cloud sono a pagamento.',
    setupSystemNamePlaceholder: 'es. Casa mia',
    setupUploadImage: 'Carica immagine',
    setupNext: 'Avanti',
    setupBack: 'Indietro',
    setupFinish: 'Fine',
    setupSkip: 'Salta',
    setupCloudPricing: 'Vedi prezzi',
    setupCloudRegistered: 'Registrato con il cloud',
  },

  // Navigation & Sidebar
  nav: {
    dashboard: 'Dashboard',
    home: 'Casa',
    rooms: 'Stanze',
    devices: 'Dispositivi',
    cameras: 'Telecamere',
    security: 'Sicurezza',
    climate: 'Clima',
    water: 'Acqua',
    appliances: 'Elettrodomestici',
    wellness: 'Benessere',
    lights: 'Luci',
    shades: 'Tende',
    energy: 'Energia',
    weather: 'Meteo',
    maintenance: 'Manutenzione',
    apps: 'App',
    main: 'Principale',
    settings: 'Impostazioni',
    media: 'Media',
    intercom: 'Citofono',
    map: 'Mappa',
  },

  roomsNav: {
    allRooms: 'Tutte le stanze',
    unassigned: 'Non assegnato',
  },

  // Settings & System
  settings: {
    settingsUpdates: {
      hubUpdateTitle: 'Aggiornamento dell’hub disponibile',
      hubUpdateBody:
        'È disponibile un nuovo aggiornamento dell’hub: v{version}. Apri Impostazioni → Sistema → Aggiornamento appliance per installarlo.',
      checkUpdates: 'Controlla aggiornamenti',
      checking: 'Controllo...',
      updateFailed: 'Aggiornamento fallito',
      downloadingUpdate: 'Download dell’aggiornamento...',
      updateReady: 'Aggiornamento pronto: riavvia per installare',
      restartInstall: 'Riavvia e installa',
      upToDate: 'Sei all’ultima versione',
      appUpdate: 'Aggiornamento app',
      checkFailed: 'Controllo aggiornamenti non riuscito',
    },
    // Addon service cards (settings/AddonServicesSection.vue): the voice
    // services and the browser & automation addon the hub runs as containers.
    addons: {
      services: 'Servizi',
      refresh: 'Aggiorna',
      noServices: 'Nessun servizio disponibile.',
      status: {
        running: 'In esecuzione',
        stopped: 'Arrestato',
        notInstalled: 'Non installato',
        installing: 'Installazione',
        updating: 'Aggiornamento',
        uninstalling: 'Disinstallazione',
        error: 'Errore',
      },
      start: 'Avvia',
      stop: 'Arresta',
      install: 'Installa',
      logs: 'Log',
      logsTitle: 'Log (ultime 100 righe)',
      generateFromDevices: 'Genera dai dispositivi',
      generating: 'Generazione...',
      availableCommands: 'Comandi disponibili',
      saveRestart: 'Salva e riavvia',
      savingRestart: 'Salvataggio e riavvio...',
      savedRestarting: 'Salvato — il contenitore si sta riavviando',
      errorPrefix: 'Errore:',
      errorLoad: 'Impossibile caricare i servizi',
      errorSaving: 'Errore nel salvataggio della configurazione',
      errorStart: 'Impossibile avviare il servizio',
      errorStop: 'Impossibile arrestare il servizio',
      errorInstall: 'Impossibile installare il servizio',
    },
  },

  // Settings Sidebar Navigation
  settingsNav: {
    configuration: 'Configurazione',
    general: 'Generale',
    torikApi: 'Torik API',
    automations: 'Automazioni',
    rooms: 'Stanze',
    devices: 'Dispositivi',
    functions: 'Funzioni',
    modes: 'Modalità',
    integrations: 'Integrazioni',
    security: 'Sicurezza',
    energy: 'Energia',
    weather: 'Meteo',
    climate: 'Clima',
    water: 'Acqua',
    appliances: 'Elettrodomestici',
    lights: 'Luci',
    shades: 'Tende',
    scenes: 'Scene',
    routines: 'Routine',
    charts: 'Grafici',
    system: 'Sistema',
    users: 'Utenti',
    presence: 'Monitoraggio presenza',
    agent: 'Agente',
    demo: 'Demo',
    backup: 'Backup',
    library: 'Libreria',
    dashboards: 'Dashboard',
    gallery: 'Galleria',
    model: 'Modello 3D',
    installer: 'Installatore',
    logs: 'Registri',
    dangerZone: 'Zona pericolosa',
  },

  // Views - Nested object for all view sections
  views: {
    // Map view (views/Map.vue + components/map/MapZonePanel.vue): the hub's own
    // geofence zones and the cloud areas the cloud owns (card `t_6b57f8f2`, plan
    // docs/plans/GEOFENCING-E2E.md §2.4). `cloudRefusal*` are read indirectly
    // (`cloudAreaRefusalNotice(...).key`) — see locales/localeAudit.ts.
    map: {
      title: 'Zone geofence',
      empty: 'Nessuna zona ancora. Creane una con «Aggiungi zona».',
      radiusMeters: 'Raggio di {meters} m',
      flyTo: 'Vai alla zona',
      editZone: 'Modifica zona',
      deleteZone: 'Elimina zona',
      zoneName: 'Nome della zona',
      radiusShort: 'Raggio (m)',
      radiusMetersLabel: 'Raggio (metri)',
      lat: 'Latitudine',
      lon: 'Longitudine',
      newZone: 'Nuova zona',
      globalZone: 'Zona globale (visibile a tutti gli utenti)',
      createZone: 'Crea zona',
      clickHint: 'Fai clic sulla mappa per creare una nuova zona',
      addZone: 'Aggiungi zona',
      moveHint: "Seleziona un'area, poi trascina la maniglia per spostarla",
      layerUsers: 'Utenti',
      layerZones: 'Zone',
      centerOnHub: 'Centra sull’hub',
      manageZones: 'Gestisci zone',
      hubMarker: 'Hub',
      sourceLocal: 'Su questo server',
      sourceCloud: 'Area cloud',
      cloudManaged: 'Gestita dal cloud',
      cloudTitle: 'Aree cloud',
      cloudAdd: 'Aggiungi area cloud',
      cloudPickHint: 'Fai clic sulla mappa per posizionare la nuova area cloud',
      cloudLoading: 'Caricamento delle aree cloud…',
      cloudEmpty: 'Nessuna area cloud ancora.',
      cloudRetry: 'Riprova',
      cloudAdminOnly: 'Solo il proprietario o un amministratore del server può modificare le sue aree cloud.',
      cloudAreaName: 'Nome dell’area',
      cloudCreate: 'Crea area',
      cloudDeleteConfirm: 'Eliminare l’area cloud "{name}"?',
      cloudRefusalForbidden: 'Questo account non può modificare le aree cloud di questo server.',
      cloudRefusalNotMember: 'Questo account non ha alcun ruolo su questo server.',
      cloudRefusalNotAdmin: 'Solo il proprietario o un amministratore del server può modificare le sue aree cloud.',
      cloudRefusalNotFound: 'Questa area cloud non esiste più.',
      cloudRefusalInvalidRadius: 'Il raggio deve essere compreso tra 50 e 5000 metri.',
      cloudRefusalInvalidArea: 'Controlla il nome e la posizione dell’area.',
      cloudRefusalGeneric: 'Il cloud ha rifiutato la modifica.',
    },

    // Rooms view
    rooms: {
      pageTitle: 'Stanze',
      searchPlaceholder: 'Cerca per stanza o area...',
      loading: 'Caricamento...',
      emptyTitle: 'Nessuna stanza',
      emptyDescription: 'Inizia creando una nuova stanza.',
      noResultsTitle: 'Nessuna stanza trovata',
      noResultsDescription: 'Prova un termine di ricerca diverso.',
      unassignedRoomsSectionTitle: 'Stanze non assegnate',
      loadError: 'Caricamento dati fallito',
    },

    // Scansione stanze (scheda `t_90febbcf`, A2): l’accesso e il suo pannello
    // (`components/scan/RoomScanEntry.vue` + `RoomScanPanel.vue`). La scansione la
    // fa il plugin nativo `RoomScan` (iOS, LiDAR); `unsupported*` sono le risposte
    // oneste di un dispositivo senza LiDAR (piano §7).
    // Scansioni 3D (card `t_8ae1d20a`, E2): la pagina delle impostazioni che
    // elenca le scansioni salvate su QUESTO hub (`views/Settings/SettingsModel.vue`),
    // con caricamento, sostituzione, download ed eliminazione.
    model: {
      title: 'Modello 3D',
      subtitle: 'L’unico modello 3D di questo hub e le scansioni con cui può essere creato.',
      homeTitle: 'Modello 3D della casa',
      homeIntro: 'Ogni pagina che mostra la casa disegna questi byte: c’è un modello per hub.',
      upload: 'Carica modello…',
      replace: 'Sostituisci…',
      download: 'Scarica',
      delete: 'Elimina',
      active: 'Attivo',
      updated: 'Aggiornato',
      loading: 'Lettura del modello…',
      loadFailed: 'Non è stato possibile leggere il modello dell’hub',
      empty: 'Non c’è ancora un modello 3D su questo hub — carica un file IFC, GLB o glTF, oppure usa una scansione 3D qui sotto.',
      uploading: 'Caricamento del modello…',
      uploadDone: 'Il modello è stato caricato.',
      uploadFailed: 'Non è stato possibile caricare il modello',
      badFormat: 'Scegli un file IFC (.ifc), GLB (.glb) o glTF (.gltf).',
      tooLarge: 'Il file del modello deve essere inferiore a 200 MB.',
      downloading: 'Download del modello…',
      downloadDone: 'Il modello è stato salvato come «{name}».',
      downloadFailed: 'Non è stato possibile scaricare il modello',
      deleting: 'Rimozione del modello…',
      deleteTitle: 'Rimuovi il modello 3D',
      deleteMessage:
        'Rimuovere il modello 3D dell’hub «{name}»? Tutte le pagine che mostrano la casa lo perdono e la vista 3D resta vuota finché non viene caricato un altro modello.',
      deleteDone: '«{name}» è stato rimosso.',
      deleteFailed: 'Non è stato possibile eliminare il modello',
      scanIsModel: '«{name}» è ora il modello 3D dell’hub.',
    },
    scans: {
      title: 'Scansioni 3D',
      subtitle: 'Scansioni delle stanze salvate su questo hub. Scansiona una stanza con la fotocamera o carica un pacchetto di acquisizione da un telefono.',
      scanRoom: 'Scansiona una stanza',
      scanRoomHint: 'Una scansione completata viene caricata su questo hub da sola.',
      uploadPackage: 'Carica pacchetto',
      refresh: 'Aggiorna',
      hubTitle: 'Sull’hub',
      deviceTitle: 'Acquisizioni su questo dispositivo',
      deviceEmpty: 'Non ci sono ancora acquisizioni su questo dispositivo.',
      deviceOnHub: 'Sull’hub',
      deviceUpload: 'Carica',
      loading: 'Caricamento delle scansioni…',
      loadFailed: 'Non è stato possibile caricare le scansioni da questo hub',
      emptyTitle: 'Nessuna scansione — scansiona la tua prima stanza',
      emptyHint:
        'Un pacchetto di scansione è la cartella che scrive un’acquisizione (scan.json, model.usdz, la pianta…). Caricane uno qui, oppure scansiona con l’app.',
      modeRoom: 'Una stanza',
      modeStructure: 'Piano',
      rooms: '{count} stanza | {count} stanze',
      files: '{count} file | {count} file',
      capturedAt: 'Acquisito',
      updatedAt: 'Aggiornato',
      download: 'Scarica',
      replace: 'Sostituisci',
      delete: 'Elimina',
      close: 'Chiudi',
      retry: 'Riprova',
      working: 'In corso…',
      reading: 'Lettura dell’acquisizione da questo dispositivo…',
      uploading: 'Caricamento sull’hub…',
      replacing: 'Sostituzione sull’hub…',
      downloading: 'Download dall’hub…',
      progress: '{percent}% caricato',
      progressUnknown: 'L’hub sta ricevendo il pacchetto…',
      uploadDone: '"{name}" è sull’hub.',
      replaceDone: '"{name}" è stato sostituito.',
      deleteDone: '"{name}" è stato eliminato dall’hub.',
      downloadDone: '"{name}" salvato — {count} file | "{name}" salvato — {count} file',
      deleteTitle: 'Eliminare questa scansione?',
      deleteMessage: 'Eliminare "{name}" dall’hub? I suoi file vengono rimossi con essa e l’operazione non è reversibile.',
      validationTitle: 'Questo pacchetto non è stato inviato',
      replaceTitle: 'Sostituisci "{name}"',
      replaceHint: 'Il nuovo pacchetto prende il posto della scansione: i file attuali vengono rimossi.',
      replaceChooseCapture: 'Un’acquisizione su questo dispositivo',
      replaceChooseFiles: 'Scegli i file da questo dispositivo…',
      replaceNoCaptures: 'Nessuna acquisizione su questo dispositivo.',
      replaceUseCapture: 'Usa questa acquisizione',
      invalid: {
        empty: 'Scegli prima i file di un pacchetto di acquisizione.',
        tooManyFiles: 'Un pacchetto contiene al massimo {max} file.',
        fileTooLarge: '"{name}" è più grande di {max} MB.',
        packageTooLarge: 'Il pacchetto è più grande di {max} MB.',
        badFileName: '"{name}" non può essere salvato — un nome di pacchetto non ha percorso, non inizia con un punto e non termina con un punto o uno spazio.',
        duplicateName: '"{name}" è nel pacchetto due volte.',
        missingUsdz: 'Il pacchetto richiede la geometria della stanza — un file .usdz.',
        badScanDoc: 'Il scan.json non è un documento torik.scan/v0.',
        generic: 'Il pacchetto non può essere inviato così com’è.',
      },
      warnings: {
        missingScanDoc: 'Nessun scan.json nel pacchetto — l’hub lo salva come acquisizione a livello di stanza.',
      },
      errors: {
        noHub: 'Questo hub non è raggiungibile in questo momento.',
        auth: 'L’hub ha rifiutato questa sessione — accedi di nuovo.',
        validation: 'L’hub ha rifiutato il pacchetto.',
        readFailed: 'Non è stato possibile leggere l’acquisizione da questo dispositivo.',
        uploadFailed: 'Il caricamento non è terminato.',
        downloadFailed: 'Il download non è terminato.',
        saveFailed: 'Non è stato possibile salvare il file su questo dispositivo.',
        unknown: 'Il trasferimento non è terminato.',
      },
      model: {
        title: 'Scansiona in 3D',
        intro: 'Scansiona una stanza con la fotocamera: la cattura finita viene caricata da sola su questo hub e ogni scansione può diventare il modello 3D della casa su questo hub.',
        scan3d: 'Scansiona in 3D',
        empty: 'Non ci sono ancora scansioni su questo hub — inizia con «Scansiona in 3D».',
        useScan: 'Usa come modello',
        selected: 'Scelto come modello',
        noModel: 'Nessun file di modello in questo pacchetto',
        loadingFile: 'Lettura della scansione dall’hub…',
        attaching: 'Collegamento della scansione come modello 3D dell’hub…',
        fetchFailed: 'Non è stato possibile leggere la scansione dall’hub',
        attachFailed: 'La scansione non è potuta diventare il modello 3D dell’hub',
      },
    },

    roomScan: {
      entryTitle: 'Scansiona le stanze con la fotocamera',
      entry: 'Scansiona',
      title: 'Scansione stanze',
      checking: 'Verifica se questo dispositivo può scansionare…',
      unsupportedTitle: 'Questo dispositivo non può scansionare le stanze',
      unsupportedLidar: 'RoomPlan richiede un iPhone Pro o un iPad Pro: è lo scanner LiDAR a misurare la stanza.',
      unsupportedPlatform: 'La scansione delle stanze funziona nell’app Torik su un iPhone Pro o iPad Pro (LiDAR).',
      errorTitle: 'La scansione non è terminata',
      nameLabel: 'Nome di questa scansione (facoltativo)',
      namePlaceholder: 'es. Soggiorno',
      startRoom: 'Scansiona una stanza',
      startStructure: 'Scansiona un intero piano',
      startHint: 'La vista fotocamera ti guida: muoviti lentamente e tieni la stanza illuminata.',
      capturingRoom: 'Scansione della stanza…',
      capturingRoomFloor: 'Scansione di questa stanza del piano…',
      capturingHint: 'Percorri la stanza, poi tocca Fine nella vista fotocamera.',
      structureRooms: 'Stanze acquisite: {count}',
      structureHint: 'Ogni «Fine» salva una stanza; «Completa» le unisce in un unico modello.',
      scanAnother: 'Scansiona un’altra stanza',
      finish: 'Completa',
      saved: 'Salvato: {label} · {count} stanza | Salvato: {label} · {count} stanze',
      scanFile: 'Dati del modello',
      capturesTitle: 'Su questo dispositivo',
      capturesEmpty: 'Non ci sono ancora scansioni su questo dispositivo.',
      modeRoom: 'Una stanza',
      modeStructure: 'Piano',
      rooms: '{count} stanza | {count} stanze',
      deleteConfirm:
        'Eliminare la scansione «{label}»? Finché non esiste il caricamento, esiste solo su questo dispositivo.',
    },

    // Devices view
    devices: {
      pageTitle: 'Dispositivi',
      searchPlaceholder: 'Cerca dispositivi...',
      groupByRooms: 'Stanze',
      groupByTypes: 'Tipi',
      loading: 'Caricamento dispositivi...',
      noResultsTitle: 'Nessun dispositivo trovato',
      noResultsDescription: 'Prova un termine di ricerca diverso.',
      emptyTitle: 'Nessun dispositivo',
      emptyDescription: 'Inizia aggiungendo un nuovo dispositivo.',
      noRoomLabel: 'Nessuna stanza',
      noRoomsWithDevicesTitle: 'Nessuna stanza con dispositivi',
      noRoomsWithDevicesDescription: 'Aggiungi dispositivi e assegnali alle stanze per vederli organizzati qui.',
      unknownType: 'Tipo sconosciuto',
      emptyTypeViewDescription: 'Aggiungi dispositivi per vederli organizzati per tipo.',
      deleteConfirmTitle: 'Elimina dispositivo',
      deleteConfirmMessage: 'Sei sicuro di voler eliminare {deviceName}?',
      cancelButton: 'Annulla',
      deleteButton: 'Elimina',
      deletingButton: 'Eliminazione...',
      loadError: 'Caricamento dati fallito',
    },

    // Scenes view
    scenes: {
      pageTitle: 'Scene',
      searchPlaceholder: 'Cerca scene...',
      addSceneButton: 'Aggiungi scena',
      reorderButton: 'Riordina',
      doneButton: 'Fatto',
      cancelButton: 'Annulla',
      deleteButton: 'Elimina',
      loading: 'Caricamento',
      emptyTitle: 'Nessuna scena ancora',
      emptyDescription: 'Crea una scena per iniziare.',
      noResultsTitle: 'Nessuna scena corrispondente',
      deleteConfirmTitle: 'Elimina scena',
      deleteConfirmMessage: 'Sei sicuro di voler eliminare',
      loadError: 'Caricamento scene fallito',
      executionSuccess: 'Scena eseguita con successo',
      executionError: 'Esecuzione completata con errori',
    },

    // Routines view
    routines: {
      pageTitle: 'Routine',
      loading: 'Caricamento routine...',
      createButton: 'Crea routine',
      editButton: 'Modifica',
      runNowButton: 'Esegui ora',
      emptyTitle: 'Nessuna routine ancora',
      emptyDescription: 'Crea la tua prima routine per automatizzare la tua casa intelligente',
      triggerCount: 'innesco | inneschi',
      conditionCount: 'condizione | condizioni',
      actionCount: 'azione | azioni',
      deleteConfirmMessage: 'Sei sicuro di voler eliminare questa routine?',
      loadError: 'Caricamento routine fallito',
      deleteError: 'Eliminazione routine fallita',
      enabledMessage: 'Routine attivata',
      disabledMessage: 'Routine disattivata',
      deletedMessage: 'Routine eliminata',
      executionStartedMessage: 'Esecuzione routine avviata',
      executionError: 'Esecuzione routine fallita',
    },

    // Media view
    media: {
      audioZonesTitle: 'Zone audio',
      newZoneButton: 'Nuova zona',
      createZoneTitle: 'Crea zona',
      noAudioZonesTitle: 'Nessuna zona audio ancora',
      noAudioZonesDescription: 'Crea una zona e aggiungi pannelli o app.',
      pausedLabel: 'In pausa',
      noMediaPlayersTitle: 'Nessun lettore multimediale',
      noMediaPlayersDescription: "Aggiungi un'integrazione Media per scoprire i lettori.",
      goToIntegrations: 'Vai alle Integrazioni',
      noLocalMediaMessage: 'Nessun contenuto multimediale nella libreria.',
    },

    // Cameras view
    cameras: {
      pageTitle: 'Telecamere',
      liveTab: 'Diretta',
      playbackTab: 'Riproduzione',
      onlineLabel: 'online',
      intercomLabel: 'citofono',
      unlockSecretCamerasTitle: 'Inserisci il PIN per vedere le telecamere segrete',
      secretButton: 'Segreto',
      editButton: 'Modifica',
      doneButton: 'Fatto',
      secretCameraTitle: 'Telecamera segreta - nascosta agli ospiti',
      loading: 'Caricamento telecamere...',
      noCamerasFoundMessage: 'Nessuna telecamera trovata. Aggiungi telecamere nelle impostazioni delle Integrazioni.',
      refreshSnapshotTitle: 'Aggiorna istantanea',
      privacyBlurTitle: 'Sfocatura privacy',
      privacyBlurMenuTitle: 'Durata della sfocatura',
      blur5Min: '5 minuti',
      blur15Min: '15 minuti',
      blur30Min: '30 minuti',
      blur1Hour: '1 ora',
      blur2Hours: '2 ore',
      removeBlurButton: 'Rimuovi sfocatura',
      muteMotionNotificationsTitle: 'Disattiva notifiche di movimento',
      muteMotionNotificationsMenuTitle: 'Disattiva notifiche di movimento per',
      unmuteMotionNotificationsButton: 'Riattiva notifiche di movimento',
      intercomBadge: 'Citofono',
      callDoorphoneTitle: 'Chiama citofono',
      editModeInstructions: 'Usa le frecce per riordinare · Clicca sul lucchetto per marcare come segreto',
      cancelButton: 'Annulla',
      savingButton: 'Salvataggio...',
      saveOrderButton: 'Salva ordine',
      selectCamerasMessage: 'Seleziona le telecamere sopra per avviare la riproduzione',
      // Una vista dal vivo il cui ICE non si completa mai: la risposta WHEP della
      // telecamera è stata accettata e nessun percorso multimediale è stato
      // stabilito. `services/mediaPath.ts` limita l’attesa e nomina lo stato;
      // i player mostrano questa frase (scheda t_20b35b28).
      mediaPathFailed:
        'Non è stato possibile stabilire il percorso multimediale verso questa telecamera — ha accettato la richiesta, ma non è stata stabilita alcuna connessione video o audio. Riprova, apri l’app propria della telecamera o controlla il log di go2rtc sull’hub.',
      // Perché il tentativo è terminato, sotto la frase (scheda t_4d5b3263): le
      // tre cause richiedono passi successivi diversi e sullo schermo compare
      // solo la causa — il censimento dei candidati e i tempi restano nella
      // console e negli avvisi di `services/mediaPath.ts`.
      mediaPathReasonBudget:
        'Nessun percorso di rete verso la telecamera è stato completato — di solito la causa è la rete dell’hub, non la telecamera.',
      mediaPathReasonFailed:
        'Il percorso di rete verso la telecamera è fallito — controlla la rete dell’hub prima di riprovare.',
      mediaPathReasonNoCandidates: 'Questo dispositivo non ha potuto preparare una connessione alla telecamera.',
    },

    // Account view
    account: {
      profileInformationTitle: 'Informazioni profilo',
      profilePictureLabel: 'Immagine profilo',
      changePictureButton: 'Cambia immagine',
      pictureFormatHint: 'PNG o JPG (max 2MB)',
      fullNameLabel: 'Nome completo',
      fullNamePlaceholder: 'Inserisci il tuo nome completo',
      emailLabel: 'Indirizzo email',
      emailPlaceholder: "utente{'@'}esempio.it",
      phoneLabel: 'Numero di telefono',
      phonePlaceholder: '+39 (3) 12 34 56 78',
      bioLabel: 'Bio',
      bioPlaceholder: 'Parla di te',
      saveProfileButton: 'Salva profilo',
      savingButton: 'Salvataggio...',
      securitySettingsTitle: 'Impostazioni sicurezza',
      changePasswordTitle: 'Cambia password',
      currentPasswordLabel: 'Password attuale',
      currentPasswordPlaceholder: 'Inserisci la password attuale',
      newPasswordLabel: 'Nuova password',
      newPasswordPlaceholder: 'Inserisci la nuova password',
      confirmPasswordLabel: 'Conferma nuova password',
      confirmPasswordPlaceholder: 'Conferma la nuova password',
      updatePasswordButton: 'Aggiorna password',
      updatingButton: 'Aggiornamento...',
      currentDeviceLabel: 'Dispositivo attuale',
      thisBrowserLabel: 'Questo browser',
      preferencesTitle: 'Preferenze',
      themeLabel: 'Tema',
      languageLabel: 'Lingua',
      notificationsTitle: 'Notifiche',
      savePreferencesButton: 'Salva preferenze',
      memberSinceLabel: 'Membro dal',
      lastLoginLabel: 'Ultimo accesso',
      sessionTitle: 'Sessione',
      logoutDescription: 'Esci dalla tua sessione attuale.',
      allFieldsRequired: 'Tutti i campi sono richiesti',
      passwordMinLengthError: 'La password deve contenere almeno 8 caratteri',
      passwordsMismatchError: 'Le password non corrispondono',
      profileTabLabel: 'Profilo',
      securityTabLabel: 'Sicurezza',
      preferencesTabLabel: 'Preferenze',
      infoTabLabel: 'Info',
      themeSystemDefault: 'Predefinito sistema',
      themeLightOption: 'Chiaro',
      themeDarkOption: 'Scuro',
      languageEnglish: 'English',
      languageSpanish: 'Español',
      languageFrench: 'Français',
      languageGerman: 'Deutsch',
      languageItalian: 'Italiano',
      languageSlovenian: 'Slovenščina',
      temperatureUnitsLabel: 'Unità temperatura',
      celsiusOption: 'Celsius (°C)',
      fahrenheitOption: 'Fahrenheit (°F)',
      notificationGroupAlerts: 'Avvisi',
      notificationGroupAlertsDetail: 'Avvisi dei dispositivi e problemi dell’hub',
      notificationGroupAutomation: 'Automazione e avvisi',
      notificationGroupAutomationDetail: 'Automazioni, routine, timer e promemoria',
      notificationGroupMessages: 'Chiamate e messaggi',
      notificationGroupMessagesDetail: 'Chiamate e messaggi di chat',
      notificationGroupPartly: 'Parzialmente attivo',
      notificationGroupsUnavailable: 'Impossibile caricare le impostazioni delle notifiche.',
      userNotifications: {
        typeDeviceAlert: 'Avvisi dei dispositivi',
        typeSystem: 'Problemi dell’hub',
        typeAutomation: 'Automazioni',
        typeRoutine: 'Routine',
        typeInfo: 'Avvisi',
        typeCall: 'Chiamate',
        typeChat: 'Messaggi di chat',
        channelPush: 'Push',
        channelInApp: 'Nell’app',
        unavailable: 'Impossibile caricare le impostazioni delle notifiche di questa persona.',
      },
      accountInformationTitle: 'Informazioni account',
      logOutButton: 'Esci',
      loggingOutButton: 'Uscita in corso...',
      notSetLabel: 'Non impostato',
      roleLabel: 'Ruolo',
      userRoleDefault: 'Utente',
      activeLabel: 'Attivo',
      otherSessionsHint: 'Altre sessioni attive appariranno qui',
    },

    // Notifications view
    notifications: {
      title: 'Notifiche',
      markAllAsRead: 'Segna tutte come lette',
      clearAll: 'Cancella tutte',
      tabAll: 'Tutte le notifiche',
      tabUnread: 'Non lette',
      tabByType: 'Per tipo',
      loading: 'Caricamento notifiche...',
      emptyState: 'Nessuna notifica ancora',
      emptyUnread: 'Tutto a posto! Nessuna notifica non letta',
      noNotificationsOfType: 'Nessuna notifica di questo tipo',
      markAsUnread: 'Segna come non letta',
      markAsRead: 'Segna come letta',
      deleteButton: 'Elimina',
      deleteAllConfirm: 'Eliminare tutte le notifiche?',
      timeJustNow: 'Proprio ora',
      timeMinutesAgo: 'min',
      timeHoursAgo: 'h',
      timeDaysAgo: 'g',
    },

    // Alarms view
    alarms: {
      title: 'Sveglie',
      newAlarm: 'Nuova sveglia',
      emptyState: 'Nessuna sveglia ancora. Tocca Nuova sveglia per iniziare.',
      editAlarmTitle: 'Modifica sveglia',
      labelField: 'Etichetta',
      labelPlaceholder: 'Sveglia',
      timeField: 'Orario',
      repeatField: 'Ripetizione',
      noDaysHelp: 'Nessun giorno selezionato = sveglia singola',
      snoozeField: 'Durata snooze (minuti)',
      soundField: 'Suono',
      cancel: 'Annulla',
      saveAlarm: 'Salva sveglia',
      saving: 'Salvataggio...',
      confirmDelete: 'Eliminare questa sveglia?',
      daysSu: 'Do',
      daysMo: 'Lu',
      daysTu: 'Ma',
      daysWe: 'Me',
      daysTh: 'Gi',
      daysFr: 'Ve',
      daysSa: 'Sa',
    },

    // People view
    people: {
      title: 'Persone',
      searchPlaceholder: 'Cerca conversazioni...',
      loading: 'Caricamento...',
      emptyPeople: 'Nessuna persona trovata',
      selfDMDescription: 'Salva messaggi, file e link',
      selfBadge: 'Io',
      selfConversationHint: 'Solo tu puoi vedere questo',
      participantsLabel: 'partecipanti',
      audioCallTitle: 'Chiamata audio',
      videoCallTitle: 'Chiamata video',
      moreOptionsTitle: 'Più opzioni',
      deleteAllMessages: 'Elimina tutti i messaggi',
      captionPlaceholder: 'Aggiungi una didascalia (opzionale)...',
      messagePlaceholder: 'Scrivi un messaggio...',
      someoneTyping: 'Qualcuno sta scrivendo...',
    },

    // Areas view

    // Integrations view
    integrations: {
      title: 'Integrazioni',
      addIntegration: 'Aggiungi integrazione',
      loading: 'Caricamento integrazioni...',
      emptyTitle: 'Nessuna integrazione',
      emptyMessage: 'Inizia aggiungendo una nuova integrazione.',
      delete: 'Elimina',
      deleteTitle: 'Elimina integrazione',
      confirmDeletePrefix: 'Sei sicuro di voler eliminare',
      confirmDeleteSuffix: ' ? Questo rimuoverà anche tutti i dispositivi associati.',
      cancel: 'Annulla',
      deleting: 'Eliminazione...',
      statusDisabled: 'Disattivata',
      statusConnected: 'Connessa',
      statusDisconnected: 'Disconnessa',
      statusDemo: 'Demo',
      demoMode: 'Modalità demo',
      demoModeOn: 'Demo attiva',
      demoModeSaving: 'Salvataggio...',
      demoModeTooltip:
        "Modalità demo: questa integrazione è scollegata dall'hardware reale e fornisce valori simulati. Disattiva per riconnetterti davvero.",
      demoModeHint: 'Simula questa integrazione — nessun traffico verso il dispositivo o bus reale.',
      demoModeActiveHint: 'Funziona con valori simulati (driver demo). Nessun hardware viene contattato.',
    },

    // Agent view
    agent: {
      title: `${brand.agentName}`,
      subtitle: 'Assistente vocale e testuale',
      reset: 'Reimposta',
      resetTitle: "Reimposta se l'agente è bloccato",
      clearButton: 'Cancella',
      history: 'Cronologia',
      emptyTitle: 'Come posso aiutarti?',
      emptyMessage: 'Prova a chiedermi di controllare dispositivi, verificare lo stato o gestire la tua casa',
      thinking: 'Pensando...',
      stop: 'Ferma',
      listeningIndicator: '🎤 In ascolto... Parla ora',
      placeholder: 'Scrivi un messaggio o usa la voce...',
      noHistory: 'Nessuna cronologia conversazioni ancora',
      suggestionLights: 'Accendi le luci del soggiorno',
      suggestionTemperature: 'Qual è la temperatura?',
      suggestionCameras: 'Mostrami le telecamere',
      suggestionScene: 'Esegui la scena buonanotte',
    },

    // Room view
    room: {
      floorLabel: 'Piano',
      addDevice: 'Aggiungi dispositivo',
      editRoom: 'Modifica stanza',
      moreActions: 'Altre azioni',
      emptyTitle: 'Nessun dispositivo in questa stanza',
      emptyMessage: 'Clicca "Aggiungi dispositivo" per aggiungerne uno a questa stanza.',
      scenesSection: 'Scene',
      chartsSection: 'Grafici',
      deleteTitle: 'Elimina dispositivo',
      confirmDeletePrefix: 'Sei sicuro di voler eliminare',
      confirmDeleteSuffix: ' ?',
      cancel: 'Annulla',
      deleting: 'Eliminazione...',
      devicesSection: 'Dispositivi',
      editLayout: 'Modifica layout',
      done: 'Fatto',
      editHint:
        'Trascina i dispositivi per riordinarli. Usa la barra degli strumenti di ogni dispositivo per scegliere come visualizzarlo.',
      dragToReorder: 'Trascina per riordinare',
      deviceSettings: 'Impostazioni dispositivo',
      displayAuto: 'Auto',
      displayButton: 'Pulsante',
      displayFull: 'Larghezza intera',
      displayIcon: 'Icona',
      addScene: 'Aggiungi scena',
      reorderScenes: 'Riordina scene',
      reorder: 'Riordina',
      dragScenesToReorder: 'Trascina le scene per riordinarle',
      layout: 'Layout',
      layoutImageAlt: 'Layout di {room}',
      dragHandle: 'trascina',
      otherType: 'Altro',
    },

    dashboardNew: {
      actionsMenuTitle: 'Azioni dashboard',
      addDashboardAction: 'Aggiungi dashboard',
      addWidgetAction: 'Aggiungi widget',
      editDashboardAction: 'Modifica dashboard',
      toggleEditModeAction: 'Attiva/disattiva modalità modifica',
      gridSettingsAction: 'Impostazioni griglia',
      loadingMessage: 'Caricamento dashboard...',
      retryButton: 'Riprova',
      defaultDashboardName: 'Dashboard',
      welcomeHeading: `Benvenuto su ${brand.platformCompact}`,
      welcomeDescription: 'Inizia creando la tua prima dashboard da un modello o da zero.',
      createDashboardButton: 'Crea dashboard',
    },

    // Settings views
    settingsSystem: {
      title: 'Impostazioni di sistema',
      systemName: 'Nome sistema',
      systemNamePlaceholder: `${brand.platformCompact}`,
      systemImage: 'Immagine sistema',
      changeImage: 'Cambia immagine',
      uploadImage: 'Carica immagine',
      removeImage: 'Rimuovi',
      imageSizeLimit: 'PNG, JPG o WebP (max 5MB)',
      imageTooLarge: 'Il file immagine è troppo grande (max 10MB)',
      imageUploaded: 'Immagine caricata con successo',
      imageRemoved: 'Immagine rimossa con successo',
      saveSystemSettings: 'Salva impostazioni di sistema',
      savingSystem: 'Salvataggio...',
      cloudServices: 'Servizi Cloud',
      connected: 'Connesso',
      disconnected: 'Disconnesso',
      connecting: 'Connessione...',
      connectionError: 'Errore di connessione',
      notRegistered: 'Non registrato',
      registerCloudDescription:
        "Registra il tuo hub con i servizi Cloud per abilitare l'accesso remoto e la condivisione.",
      cloudAccount: 'Account Cloud',
      cloudAccountEmail: 'Email account Cloud',
      emailPlaceholder: "email{'@'}example.com",
      cloudUrl: 'URL Cloud',
      registerWithCloud: 'Registra con Cloud',
      registering: 'Registrazione...',
      reconnect: 'Riconnetti',
      reconnecting: 'Riconnessione...',
      unregister: 'Annulla registrazione',
      unregistering: 'Annullamento registrazione...',
      sharedWith: 'Condiviso con',
      hubNotShared: 'Questo hub non è condiviso con nessun altro.',
      removeAccess: 'Rimuovi',
      viewOnly: 'Solo visualizzazione',
      control: 'Controllo',
      admin: 'Admin',
      emailToSharePlaceholder: "utente{'@'}example.com",
      add: 'Aggiungi',
      adding: 'Aggiunta in corso...',
      loading: 'Caricamento...',
      saving: 'Salvataggio...',
      settingsSaved: 'Impostazioni salvate con successo',
      hubLocation: 'Posizione hub',
      locationDescription:
        "La posizione dell'hub viene utilizzata per le previsioni meteorologiche e i calcoli dell'alba/tramonto.",
      automaticLocation: 'Automatico',
      manual: 'Manuale',
      pickLocation: 'Seleziona posizione sulla mappa',
      latitude: 'Latitudine',
      latitudePlaceholder: 'es. 46.1199',
      longitude: 'Longitudine',
      longitudePlaceholder: 'es. 14.4992',
      elevation: 'Altitudine (metri)',
      elevationPlaceholder: 'es. 500',
      location: 'Posizione',
      saveHubLocation: 'Salva posizione hub',
      weather: 'Meteo',
      weatherLocation: 'Posizione meteo',
      searchCityPlaceholder: 'Inserisci nome città',
      units: 'Unità',
      metric: 'Metrico (°C, m/s)',
      imperial: 'Imperiale (°F, mph)',
      saveWeatherSettings: 'Salva impostazioni meteo',
      cityRequired: 'La città è obbligatoria',
      weatherSettingsSaved: 'Impostazioni meteo salvate',
      citySearchFailed: 'Ricerca città non riuscita',
      searchCity: 'Cerca città',
      enterCityName: 'Inserisci nome città',
      searching: 'Ricerca in corso...',
      search: 'Cerca',
      noCitiesFound: 'Nessuna città trovata',
      enterCitySearch: 'Inserisci almeno 2 caratteri per cercare',
      close: 'Chiudi',
      checkForUpdates: 'Controlla aggiornamenti',
      checking: 'Controllo...',
      confirmInstall: "Installare l'aggiornamento? Il sistema si riavvierà.",
      confirmRollback: 'Eseguire il rollback? Il sistema si riavvierà.',
      installUpdate: 'Installa aggiornamento',
      installing: 'Installazione...',
      systemUpdates: 'Aggiornamenti sistema',
      securityUpdateTooltip: 'Aggiornamento di sicurezza',
      currentVersionLabel: 'Versione attuale',
      channelLabel: 'Canale',
      lastCheckedLabel: 'Ultimo controllo',
      updateAvailableLabel: 'Aggiornamento disponibile',
      lastUpdatedLabel: 'Ultimo aggiornamento',
      kernelLabel: 'kernel',
      checkingForUpdates: 'Ricerca di aggiornamenti...',
      applianceUpdateHint: "Fai clic su Cerca aggiornamenti per verificare nuove release dell'appliance.",
      platformdUpToDate: 'Il daemon della piattaforma è aggiornato.',
      platformdNoUpdate: 'Nessun aggiornamento disponibile per il daemon della piattaforma.',
      platformdUpdateHint: 'Fai clic su Cerca aggiornamenti per verificare le release del daemon della piattaforma.',
      systemUpdatesDisabled: 'Gli aggiornamenti di sistema non sono abilitati su questo dispositivo.',
      platformdUpdate: 'Daemon della piattaforma',
      platformdUpdateDescription: "Servizio di sistema che gestisce rete, hardware e aggiornamenti dell'appliance",
      installPlatformd: 'Aggiorna il daemon della piattaforma',
      confirmInstallPlatformd: 'Aggiornare il daemon della piattaforma? Il servizio si riavvierà brevemente.',
      platformdUpdateInProgress:
        'Aggiornamento del daemon della piattaforma in corso — il servizio si riavvierà al termine.',
      licence: 'Licenza',
      manageLicence: 'Gestisci licenza',
      noPlan: 'Nessun piano',
      unlimitedSeats: 'Postazioni illimitate',
      oneSeat: '1 postazione',
      seats: 'postazioni',
      ownerOnly: 'Solo il proprietario',
      accessLocalOnly: 'Solo accesso locale',
      accessRemote: 'Accesso remoto',
      licensedApps: 'App',
      licenceNeedsRegistration: 'Registra questo server qui sopra per ricevere la sua licenza dal cloud.',
      licencePending:
        'In attesa che il cloud confermi la licenza di questo server — si aggiorna da solo entro un minuto.',
      licenceStale: 'Non confermata di recente',
      licenceStaleHint: "Il cloud non conferma questa licenza da un po' — controlla la connessione qui sopra.",
      licenceGrantedTo: 'Concessa a',
      licenceConfirmed: 'Ultima conferma dal cloud',
      justNow: 'proprio ora',
      minutesAgo: 'minuti fa',
      hourAgo: 'ora fa',
      hoursAgo: 'ore fa',
      systemIcon: 'Icona di sistema',
      systemIconType: 'Tipo di icona',
      systemIconGenerated: 'Generato automaticamente',
      systemIconCustom: 'Immagine personalizzata',
      systemIconColor: 'Colore sfondo',
      systemIconTextColor: 'Colore testo',
      systemIconUpload: 'Carica icona',
      systemIconPreview: 'Anteprima',
      systemIconSizeLimit: 'Solo PNG (max 500KB)',
      systemIconSaved: 'Impostazioni icona di sistema salvate',
      saveSystemIconSettings: 'Salva impostazioni icona di sistema',
      systemIconReset: 'Ripristina predefinito',
      systemIconResetConfirm: "Ripristinare l'icona di sistema predefinita?",
      systemIconResetDone: 'Icona di sistema ripristinata',
      applianceUpdate: 'Aggiornamento appliance',
      applianceUpdateDescription: `Aggiornamenti del software dell'hub ${brand.agentName} e dei pacchetti di sistema`,
      confirmInstallSystem:
        'Installare tutti gli aggiornamenti dei pacchetti di sistema? Può richiedere diversi minuti. Il sistema continuerà a funzionare.',
      installAll: 'Installa tutti gli aggiornamenti',
      rollback: 'Torna alla versione precedente',
      rollingBack: 'Ripristino in corso...',
      upToDate: 'Il sistema è aggiornato',
      updateInProgress: "Aggiornamento in corso — l'hub si riavvierà al termine.",
      updateCheckFailed: 'Verifica degli aggiornamenti del dispositivo non riuscita.',
      updateStatusInProgress: 'È in corso un aggiornamento.',
      updateInstalling: "L'aggiornamento è in installazione — l'hub si riavvierà al termine.",
      updateStatusInstalling: "L'aggiornamento è in installazione — l'hub si riavvierà al termine.",
      updateStatusNotRegistered:
        'Per consentire a questo hub di cercare le versioni del dispositivo è necessaria la registrazione al cloud.',
      updateStatusBlocked:
        "Questo hub necessita di un aggiornamento intermedio prima di poter installare l'ultima versione del dispositivo.",
      updateStatusNoRelease:
        'Per questo canale non è attualmente disponibile alcuna versione pubblicata del dispositivo.',
      updateStatusUpToDate: "Questo hub utilizza già l'ultima versione pubblicata del dispositivo.",
      updateStatusUnreachable: 'Impossibile raggiungere il servizio di aggiornamento.',
      updateStatusNoUpdate: 'Al momento non è disponibile alcun aggiornamento del dispositivo.',
      updateStarted:
        "Aggiornamento avviato. L'hub si riavvierà se viene installata una nuova versione del dispositivo.",
      updateStartFailed: "Avvio dell'aggiornamento del dispositivo non riuscito.",
      rollbackInitiated: "Ripristino avviato. L'hub si riavvierà se è disponibile un'immagine di ripristino.",
      rollbackStartFailed: 'Avvio del ripristino non riuscito.',
      systemUpdateCheckFailed: 'Verifica degli aggiornamenti di sistema non riuscita',
      systemInstallFailed: 'Installazione non riuscita',
    },

    settingsUsers: {
      usersManagement: 'Persone e dispositivi',
      peopleSectionTitle: 'Persone',
      peopleSectionHint:
        'Tutti quelli che hanno un ruolo su questo hub. Una persona accede con il suo account Torik — nessuna password locale.',
      peopleEmpty: 'Non c’è ancora nessuno su questo hub. Invita la prima persona via email.',
      serverOwnerRow: 'Proprietario di questo server',
      accountLinked: 'Collegato a {email}',
      accountNotLinkedWithEmail: 'Nessun account collegato — {email}',
      accountNotLinked: 'Nessun account collegato',
      inviteDescription:
        'Invia un invito via email. La persona lo accetta mentre è connessa al suo account Torik — nessuna password e nessun codice.',
      inviteRoleHint: 'Ricevono il ruolo {role} su questo hub.',
      addUser: 'Aggiungi utente',
      usersLoading: 'Caricamento utenti...',
      done: 'Fatto',
      passwordNotAvailable: 'Questo account accede con il suo account Torik o un invito — non ha una password locale.',
      editPersonTitle: 'Modifica persona',
      deviceListTitle: 'Dispositivi connessi',
      deviceLastSeen: 'Ultimo accesso {date}',
    },

    settingsBackup: {
      title: 'Backup e ripristino',
      automaticBackupSettings: 'Impostazioni backup automatico',
      createBackup: 'Crea backup',
      creatingBackup: 'Creazione...',
      backupCreated: 'Backup creato con successo',
      backupFailed: 'Creazione backup fallita',
      configurationOnlyInfo:
        'Questi backup includono solo la configurazione. File multimediali, registrazioni delle telecamere, istantanee delle telecamere e storico dei valori registrati sono esclusi.',
      settingsSaved: 'Impostazioni backup salvate',
      settingsLoadFailed: 'Impossibile caricare le impostazioni di backup',
      settingsSaveFailed: 'Impossibile salvare le impostazioni di backup',
      backupBeforeUpgrade: "Crea backup prima dell'aggiornamento",
      backupBeforeUpgradeDesc:
        'Crea automaticamente un backup della configurazione prima di installare un aggiornamento software.',
      weeklyEnabled: 'Abilita backup settimanali',
      weeklyEnabledDesc: 'Crea un backup della configurazione ogni settimana secondo la pianificazione seguente.',
      weeklyDay: 'Giorno del backup',
      weeklyTime: 'Ora del backup',
      keepBackupsCount: 'Backup conservati sul server',
      keepBackupsCountHelp:
        'I file di backup locali più vecchi vengono eliminati automaticamente dopo la creazione di nuovi backup.',
      destinationSettings: 'Destinazioni del backup',
      networkCopyEnabled: 'Copia il backup in una posizione di rete',
      networkCopyEnabledDesc:
        'Dopo la creazione del backup locale del server, lo stesso file viene copiato in una cartella di rete o in una condivisione montata.',
      networkBackupPath: 'Percorso di rete del backup',
      networkBackupPathPlaceholder: '\\\\nas\\otto\\backups o /mnt/backups/otto',
      networkBackupPathHelp:
        'Usa un percorso UNC raggiungibile o una cartella montata. La conservazione locale sul server continua ad applicarsi solo alla cartella di backup del server.',
      cloudStorageTitle: 'Archiviazione cloud per abbonati',
      cloudStorageDesc: "L'archiviazione cloud per abbonati userà lo stesso pacchetto di backup della configurazione.",
      cloudStorageComingSoon:
        "Il caricamento nel cloud non è ancora attivo. Sarà abilitato quando sarà disponibile l'endpoint di backup per gli abbonati.",
      localRetentionNote:
        'I backup manuali usano lo stesso pacchetto di configurazione e seguono la stessa impostazione di conservazione locale.',
      availableBackups: 'Backup disponibili',
      noBackups: 'Nessun backup disponibile',
      download: 'Scarica',
      delete: 'Elimina',
      deleteBackup: 'Elimina backup',
      confirmDeleteBackup: 'Sei sicuro di voler eliminare questo backup?',
      backupDeleted: 'Backup eliminato',
      restoreFromBackup: 'Ripristina da backup',
      warning:
        'Avvertenza: Il ripristino da backup sovrascriverà tutti i dati correnti. Il sistema si riavvierà dopo il ripristino.',
      selectBackupFile: 'Seleziona il file di backup da ripristinare',
      restoringBackup: 'Ripristino...',
      restoring: 'Ripristino...',
      validating: 'Validazione...',
      backupRestored: 'Backup ripristinato con successo',
      restoreFailed: 'Ripristino backup fallito',
      confirmRestore: 'Questo sovrascriverà tutti i dati correnti. Continuare?',
      confirmRestoreTitle: 'Conferma ripristino',
      validationWarnings: 'Avvisi',
      backupInfo: 'Informazioni sul backup',
      backupVersion: 'Versione',
      backupDate: 'Data',
      incompatibleWarning:
        'Lo schema del database non è compatibile. Il ripristino potrebbe causare errori o perdita di dati.',
      restoreInitiated: 'Il ripristino è stato avviato. Il sistema si riavvierà a breve.',
      filename: 'Nome file',
      created: 'Creato il',
      fileSize: 'Dimensione file',
      downloadBackup: 'Scarica backup',
      selectFile: 'Seleziona file',
      deleteConfirm: 'Eliminare {filename}?',
      downloadFailed: 'Download fallito',
      acceptedFormats: '.otto_backup, .ottohome_backup, .1hub_backup',
      restoreWizardStep1: 'Seleziona file di backup',
      restoreWizardStep2: 'Controlla backup',
      restoreWizardStep3: 'Opzioni di ripristino',
      restoreWizardStep4: 'Conferma ripristino',
      restoreWizardCrossServerBanner: 'Questo backup proviene da un server diverso.',
      restoreWizardCrossServerInfo:
        "Le password utente usano bcrypt e sono portabili. Gli utenti esistenti possono accedere con le loro password. Il server verrà riavviato dopo il ripristino - dovrai effettuare di nuovo l'accesso.",
      restoreWizardCreateRecoveryAdmin: 'Crea un amministratore di recupero',
      restoreWizardRecoveryUsername: 'Nome utente amministratore',
      restoreWizardRecoveryPassword: 'Password amministratore',
      restoreWizardRecoveryAdminDesc:
        'Garantisce che almeno un account amministratore funzioni dopo un ripristino tra server.',
      restoreWizardPreserveHubId: "Mantieni l'identità attuale del server",
      restoreWizardPreserveHubIdDesc: "Impedisce di sovrascrivere l'ID univoco di questo server (consigliato).",
      restoreWizardSummaryDb: 'Il database verrà sostituito con il contenuto del backup.',
      restoreWizardSummaryFiles: 'Upload, dati Matter e immagini di sistema verranno ripristinati.',
      restoreWizardFinalWarning:
        'Il server verrà riavviato dopo il ripristino. Tutti gli utenti connessi verranno disconnessi.',
      restoreWizardUserCount: '{count} account utente nel backup',
      restoreWizardTableCount: '{count} tabelle del database nel backup',
      restoreWizardRestoreButton: 'Ripristina backup',
      restoreWizardRestoring: 'Ripristino del backup...',
      restoreWizardUploading: 'Caricamento del file di backup...',
      restoreWizardRestoreComplete: 'Ripristino completato!',
      restoreWizardRestarting:
        'Il sistema si sta riavviando. Verrai reindirizzato alla pagina di accesso tra {seconds} secondi...',
      restoreWizardContinue: 'Continua',
      restoreWizardBack: 'Indietro',
      restoreWizardValidating: 'Validazione del file di backup...',
      restoreWizardValidationFailed: 'Impossibile validare il file di backup.',
      valuesBackupTitle: 'Backup dei valori',
      valuesBackupDesc:
        'Esegue il backup dello storico dei valori dei dispositivi (log analogici, log dei contatori, log dei valori). Il file viene scaricato direttamente e non viene salvato sul server.',
      exportValuesBackup: 'Esporta backup dei valori',
      exportingValues: 'Esportazione backup dei valori...',
      valuesRestoreTitle: 'Ripristina valori',
      valuesRestoreDesc: 'Ripristina lo storico dei valori da un precedente file di backup dei valori.',
      valuesRestoreInfo:
        'Vengono importate solo le righe con valori dispositivo corrispondenti. I valori di dispositivi inesistenti vengono saltati. Si tratta di una fusione - i dati esistenti vengono mantenuti.',
      selectValuesBackup: 'Seleziona file di backup dei valori',
      importingValues: 'Importazione backup dei valori...',
      valuesRestoreResult: 'Valori ripristinati: {inserted} inseriti, {skipped} saltati',
      valuesRestoreFailed: 'Ripristino del backup dei valori non riuscito',
    },

    settingsAgent: {
      configuration: 'Configurazione',
      voice: 'Voce',
      enableAgent: 'Attiva agente',
      enableAgentDesc: "Attiva l'agente IA per aiutarti con i comandi vocali e l'automazione della casa intelligente.",
      wakeWord: 'Parola di attivazione',
      wakeWordDesc: `Scegli il comando vocale che attiva l'agente (ad es. "Hey ${brand.agentName}", "OK Nabu").`,
      voiceDesc: "Seleziona la tua voce preferita per le risposte dell'agente.",
      autoListen: 'Ascolto automatico',
      autoListenDesc:
        "Avvia automaticamente l'ascolto dopo la risposta dell'agente, consentendo una conversazione continua.",
      confirmActions: 'Conferma azioni',
      confirmActionsDesc: "Richiedi la conferma dell'utente prima di eseguire i comandi automatizzati.",
      settings: 'Impostazioni',
      saving: 'Salvataggio...',
      voiceServices: 'Servizi vocali',
      browserServices: 'Browser e automazione',
    },

    settingsDevices: {
      searchDevices: 'Cerca dispositivi...',
    },

    settingsDangerZone: {
      dangerZone: 'Zona pericolosa',
      deleteAllRooms: 'Elimina tutte le stanze',
      deleteAllRoomsDesc:
        'Elimina permanentemente tutte le stanze e le loro configurazioni. Questa azione non può essere annullata.',
      deleteAllDevices: 'Elimina tutti i dispositivi',
      deleteAllDevicesDesc:
        'Elimina permanentemente tutti i dispositivi e le loro impostazioni. Questa azione non può essere annullata.',
      deleteAllIntegrations: 'Elimina tutte le integrazioni',
      deleteAllIntegrationsDesc: 'Disconnette e elimina tutte le integrazioni. Questa azione non può essere annullata.',
      deleteAllScenes: 'Elimina tutte le scene',
      deleteAllScenesDesc:
        'Elimina permanentemente tutte le scene e le automazioni. Questa azione non può essere annullata.',
      factoryReset: 'Ripristino di fabbrica',
      warning: 'Avvertenza: Questa azione non può essere annullata.',
      resetting: 'Ripristino in corso...',
    },

    settingsLogs: {
      title: 'Log di sistema',
      logRetention: 'Pulizia registri',
      logRetentionDescription:
        'Elimina automaticamente i vecchi record dalle tabelle di registro. Configura quanti giorni conservare i dati.',
      valueLogsRetention: 'Registri valori',
      scriptExecutionLogRetention: 'Registro esecuzione script',
      presenceEventsRetention: 'Eventi di presenza',
      intercomCallsRetention: 'Chiamate interfono',
      notificationsRetention: 'Notifiche',
      eventsRetention: 'Eventi di sistema',
      sceneExecutionsRetention: 'Esecuzioni scene',
      messagesRetention: 'Messaggi',
      days: 'giorni',
      saveLogRetention: 'Salva impostazioni pulizia',
      cleanNow: 'Pulisci ora',
      cleaning: 'Pulizia...',
      cleanNowConfirm: 'Sei sicuro? I vecchi record verranno eliminati definitivamente.',
      logRetentionSaved: 'Impostazioni di pulizia registri salvate',
      logCleanupDone: 'Pulizia completata: {count} record eliminati',
      saving: 'Salvataggio...',
    },

    settingsPlatform: {
      title: 'Piattaforma',
      storage: 'Archiviazione',
      dockerEngine: 'Motore',
      dockerCli: 'CLI',
      hardwareDescription: 'Profilo hardware della piattaforma e stato GPIO',
      testHardware: 'Testa hardware',
      hardwareTest: 'Test hardware',
      hardwareTestDescription: 'Controlla il LED di sistema e simula le pressioni dei pulsanti per i test.',
      ledCurrent: 'Stato LED attuale',
      cancel: 'Annulla',
      close: 'Chiudi',
      timeConfiguration: 'Configurazione ora',
      timezone: 'Fuso orario',
      loadingTimezones: 'Caricamento fusi orari...',
      ntpServers: 'Server NTP',
      ntpPlaceholder: 'ntp.example.com, pool.ntp.org',
      ntpDescription: 'Elenco separato da virgole di server NTP. Lasciare vuoto per i server predefiniti.',
      saveTimeSettings: 'Salva impostazioni ora',
      timeSettingsSaved: 'Impostazioni ora salvate con successo',
      refresh: 'Aggiorna',
      refreshing: 'Aggiornamento...',
      daemon: 'Daemon di piattaforma',
      noUrlConfigured: 'Nessun URL configurato',
      version: 'Versione',
      uptime: 'Tempo di attività',
      profile: 'Profilo',
      mode: 'Modalità',
      mock: 'Simulazione',
      hardwareMode: 'Hardware',
      hardware: 'Hardware',
      gpioConfigured: 'GPIO configurato',
      mockGpio: 'GPIO simulato',
      systemLed: 'LED di sistema',
      fan: 'Ventola',
      capabilities: 'Capacità',
      ledState: 'Stato LED',
      apply: 'Applica',
      applying: 'Applicazione...',
      buttonPress: 'Pressione pulsante',
      buttonShort: 'Breve',
      buttonMedium: 'Media',
      buttonLong: 'Lunga',
      buttonVeryLong: 'Molto lunga',
      simulate: 'Simula',
      simulating: 'Simulazione...',
      host: 'Host',
      hostname: 'Nome host',
      runtime: 'Ambiente di esecuzione',
      systemUptime: 'Tempo attività sistema',
      memory: 'Memoria',
      temperature: 'Temperatura',
      loadAverage: 'Carico medio',
      dockerServices: 'Servizi Docker',
      available: 'Disponibile',
      unavailable: 'Non disponibile',
      restart: 'Riavvia',
      restarting: 'Riavvio...',
      noContainersReported: 'Nessun container segnalato.',
      power: 'Alimentazione',
      enabled: 'Attivato',
      disabled: 'Disattivato',
      platform: 'Piattaforma',
      command: 'Comando',
      requesting: 'Richiesta in corso...',
      reboot: 'Riavvia',
      shutdown: 'Spegni',
      events: 'Eventi',
      noEventsReported: 'Nessun evento segnalato.',
      loadingStatus: 'Caricamento stato',
      notConfigured: 'Non configurato',
      connected: 'Connesso',
      disconnected: 'Disconnesso',
      none: 'Nessuno',
      na: 'n/d',
      noStatus: 'Nessuno stato',
      of: 'di',
      running: 'in esecuzione',
      unknown: 'Sconosciuto',
      ledBooting: 'Avvio',
      ledHealthy: 'Operativo',
      ledDegraded: 'Degradato',
      ledOffline: 'Offline',
      ledUpdating: 'Aggiornamento',
      ledError: 'Errore',
      ledFactoryResetPending: 'Ripristino di fabbrica in sospeso',
      ledUnknown: 'Sconosciuto',
      confirmRestart: 'Riavviare {name}?',
      confirmReboot: "Riavviare l'host?",
      confirmShutdown: "Spegnere l'host?",
      se: {
        mode: 'Modalità',
        type: 'Tipo',
        notFound: 'Non trovato',
        error: 'Errore',
        title: 'Elemento sicuro',
        description: 'Coprocessore crittografico hardware per la certificazione Matter',
        serial: 'Numero di serie',
        i2C: 'Bus I²C',
        provisioned: 'Provisionato',
        present: 'Presente',
        yes: '✓ Sì',
        no: 'Non ancora',
      },
      monitoring: {
        title: 'Monitoraggio sistema',
        description:
          'Configura avvisi per le soglie di utilizzo del disco. Le notifiche vengono inviate agli amministratori quando i limiti vengono raggiunti.',
        alerts: 'Avvisi',
        diskWarning: 'Soglia di avviso disco',
        diskCritical: 'Soglia critica disco',
        save: 'Salva impostazioni di monitoraggio',
        diskUsage: 'Disco',
        offlineNotice:
          'Il daemon della piattaforma è offline — le soglie possono essere valori locali di ripiego e non possono essere salvate.',
      },
      network: {
        title: 'Rete',
        description: 'Gestione delle interfacce di rete, del WiFi e del nome host',
        hostname: 'Nome host',
        gateway: 'Gateway predefinito',
        gatewayShort: 'GW',
        dns: 'Server DNS',
        backend: 'Backend',
        default: 'Predefinito',
        noInterfaces: 'Nessuna interfaccia segnalata.',
        connectSsid: 'WiFi SSID',
        ssidPlaceholder: 'Scansiona o digita un SSID',
        password: 'Password',
        passwordPlaceholder: 'Password WiFi',
        scan: 'Scansiona',
        scanning: 'Scansione...',
        connect: 'Connetti',
        connecting: 'Connessione...',
        saveHostname: 'Salva nome host',
        resetDhcp: 'Ripristina la rete cablata su DHCP',
        resetting: 'Ripristino...',
        error: 'Errore',
        confirmHostname:
          "Cambiare il nome host in {hostname}? Questo può influire sull'accesso mDNS (ad es. {hostname}.local).",
        confirmResetDhcp: "Ripristinare l'interfaccia cablata su DHCP? Questo può cambiare l'indirizzo IP.",
        configure: 'Configura',
        static: 'IP statico',
        dhcp: 'DHCP',
        methodLabel: 'Metodo',
        ipConfig: 'Configurazione IP',
        ipAddress: 'Indirizzo IP',
        prefix: 'Prefisso',
        dnsDescription: 'Server DNS separati da virgole.',
        dhcpDescription: "L'interfaccia otterrà automaticamente indirizzo IP, gateway e DNS dalla rete.",
        confirmStatic: 'Impostare {iface} su un IP statico ({address})? La connessione verrà brevemente interrotta.',
        confirmDhcp: 'Impostare {iface} su DHCP? La connessione verrà brevemente interrotta.',
        wifi: 'WiFi',
        wired: 'Cablata',
      },
      saving: 'Salvataggio...',
    },

    integrationCameras: {
      loadingState: 'Caricamento telecamere...',
      camerasTab: 'Telecamere',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      statusConnected: 'Connesso',
      statusReady: 'Pronto',
      nvr: {
        serverSection: 'Condividi questo hub (server NVR)',
        serverSectionHint: `Altri hub ${brand.platformCompact} possono connettersi qui e guardare le telecamere che assegni loro.`,
        connectionInfo: 'Info connessione',
        hubUrl: "URL hub (usato come URL master sull'altro hub)",
        newClient: 'Nuovo client',
        clientName: 'Nome client',
        createClient: 'Crea',
        enabled: 'Attivato',
        disabled: 'Disattivato',
        clientsTitle: 'Client (altri hub)',
        noClients: 'Nessun client ancora — creane uno per ottenere un token monouso.',
        tokenTitle: 'Token client monouso',
        tokenHint:
          "Incolla questo token nell'altro hub quando aggiungi una sorgente NVR. Viene mostrato una sola volta.",
        close: 'Chiudi',
        assignedCameras: 'Telecamere assegnate',
        saveAssignment: 'Salva telecamere',
        lastSeen: 'Ultima visualizzazione',
        neverSeen: 'Mai connesso',
        deleteClient: 'Elimina',
        remoteClient: 'Remoto',
        sourceSection: 'Altri hub (sorgenti NVR)',
        sourceSectionHint:
          "Aggiungi un hub che condivide le telecamere con te, poi importa le sue telecamere. Le telecamere importate sono thin client — la registrazione avviene sull'hub di origine.",
        addSource: 'Aggiungi sorgente',
        sourceName: 'Nome',
        masterUrl: 'URL hub',
        masterUrlHint:
          "URL di base dell'altro hub, ad es. https://my-hub. La sua API è servita sotto /api — sono accettati sia https://my-hub sia https://my-hub/api.",
        token: 'Token',
        test: 'Testa',
        testOk: 'Raggiungibile',
        testFail: 'Fallito',
        showCameras: 'Mostra telecamere',
        importSelected: 'Importa selezionate',
        noRemoteCameras: 'Questo hub non ti ha ancora assegnato telecamere.',
        remoteCamerasTitle: "Telecamere disponibili sull'hub di origine",
        importedTitle: 'Importate su questo hub',
        noImported: 'Nessuna telecamera importata.',
        remove: 'Rimuovi',
        removeAll: 'Rimuovi tutto',
        sync: 'Sincronizza',
        adminRequired: 'Solo gli amministratori possono gestire la condivisione NVR.',
        error: 'Impossibile caricare le impostazioni di condivisione NVR.',
      },
      nvrTab: 'NVR',
    },

    integrationDatapoints: {
      backButton: 'Torna alle Integrazioni',
      pageTitle: 'Punti dati',
      loadingState: 'Caricamento punti dati...',
      statusConnected: 'Connesso',
      statusDisconnected: 'Disconnesso',
      errorMessage: 'Caricamento punti dati fallito',
    },

    integrationHomeAssistant: {
      entitiesTab: 'Entità',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      loadingState: 'Caricamento dati Home Assistant...',
      errorMessage: 'Connessione a Home Assistant fallita',
    },
    settingsTorikApi: {
      cancel: 'Annulla',
      title: 'Torik API',
      subtitle: 'API REST + WebSocket compatibile con Home Assistant per strumenti esterni e collegamenti hub-to-hub.',
      refresh: 'Aggiorna',
      running: 'Server API in esecuzione',
      stopped: 'Server API arrestato',
      port: 'Porta',
      clients: 'Client connessi',
      tokenCount: 'Token attivi',
      enabled: 'Attivato',
      enabledToast: 'API Torik attivata',
      disabledToast: 'API Torik disattivata',
      endpoints: 'Endpoint',
      authHint: `Autenticati con "Authorization: Bearer ***" (WebSocket: {'{'}"type":"auth","access_token":"<token>"{'}'}).`,
      tokensTitle: 'Token di accesso',
      tokensHint: "Token bearer a lunga durata. Creane uno qui e incollalo nell'hub che si collega.",
      newToken: 'Nuovo token',
      noTokens: 'Nessun token API ancora.',
      lastUsed: 'ultimo utilizzo',
      never: 'mai',
      active: 'Attivo',
      disabled: 'Disattivato',
      delete: 'Elimina',
      deleteConfirm: "Eliminare questo token? I client che lo usano perdono subito l'accesso.",
      deleted: 'Token eliminato',
      createTitle: 'Crea token API',
      tokenCreatedTitle: 'Token creato',
      tokenName: 'Nome token',
      tokenNamePlaceholder: 'ad es. hub secondario, Node-RED',
      creating: 'Creazione...',
      create: 'Crea',
      copyWarning: 'Copia questo token ora — viene mostrato una sola volta.',
      copy: 'Copia',
      copied: 'Token copiato',
      copyFailed: 'Copia fallita',
      done: 'Fatto',
    },

    integrationKNX: {
      statusDisabled: 'Disattivato',
      statusConnected: 'Connesso',
      statusDisconnected: 'Disconnesso',
      deleteAllDevicesButton: 'Elimina tutti i dispositivi',
      loadingState: 'Caricamento dati KNX...',
      settingsTab: 'Impostazioni',
      datapointsTab: 'Punti dati',
      devicesTab: 'Dispositivi',
      groupMonitorTab: 'Monitor gruppo',
      busMonitorTab: 'Monitor bus',
      logsTab: 'Log',
      remoteAccessTab: 'Accesso remoto',
      deleteModalTitle: 'Elimina tutti i dispositivi KNX',
      deleteConfirmMessage:
        'Sei sicuro di voler eliminare tutti i dispositivi KNX? Questa azione non può essere annullata.',
      deleteConfirmLabel: 'Per confermare, digita "DELETE" qui sotto:',
      deleteConfirmPlaceholder: 'Digita DELETE per confermare',
      cancelButton: 'Annulla',
      deleteConfirmButton: 'Elimina tutti i dispositivi',
      deletingState: 'Eliminazione dispositivi...',
      errorMessage: 'Elaborazione richiesta KNX fallita',
    },

    remoteSupport: {
      selectIntegration: 'Seleziona integrazione KNX',
      selectIntegrationPlaceholder: 'Scegli integrazione KNX...',
      knxRemoteSupport: 'Supporto remoto KNX',
      tpuartTitle: 'Driver TP-UART richiesto',
      tpuartDesc:
        "La condivisione dell'interfaccia KNX tramite driver TP-UART sarà disponibile quando il demone della piattaforma la supporterà.",
      remoteUsers: 'Utenti supporto remoto',
      remoteUsersDesc:
        'Gestisci utenti che possono fornire supporto remoto. Aggiungi utenti per email e configura i limiti di tempo di accesso.',
      addUserByEmail: 'Aggiungi utente per email',
      emailPlaceholder: "utente{'@'}esempio.it",
      addUser: 'Aggiungi',
      adding: 'Aggiunta...',
      remove: 'Rimuovi',
      removing: 'Rimozione...',
      installerRole: 'Installatore',
      noEmail: 'Nessuna email',
      noRemoteUsers: 'Nessun utente di supporto remoto aggiunto.',
      editAccess: 'Modifica',
      day: 'Giorno',
      days: 'Giorni',
      daysAccess: 'giorni di accesso',
      perSession: 'per sessione',
      unlimited: 'Illimitato',
      unlimitedAccess: 'Accesso illimitato',
      confirmRemoveUser: 'Rimuovere {name} dal supporto remoto? Il suo account verrà convertito in utente normale.',
      accessDaysPrompt: 'Durata accesso (giorni, 0 = illimitato):',
      accessHoursPrompt: 'Ore max per sessione:',
      newSession: 'Nuova sessione di supporto',
      selectUser: 'Seleziona utente',
      selectUserPlaceholder: 'Scegli utente...',
      timeWindow: 'Durata sessione',
      createSession: 'Crea sessione',
      creating: 'Creazione...',
      endSession: 'Termina sessione',
      ending: 'Terminazione...',
      activeSessions: 'Sessioni attive',
      installerLabel: 'Installatore',
      timeRemaining: 'Tempo rimanente',
      expired: 'Scaduto',
      justNow: 'proprio ora',
      ago: 'fa',
      hour: 'Ora',
      hours: 'Ore',
      minutes: 'Minuti',
      send: 'Invia',
      messagePlaceholder: 'Scrivi un messaggio...',
      noMessages: 'Nessun messaggio ancora.',
      issueReport: 'Segnalazione problema / Chat',
      issueReportDesc: "Invia un messaggio all'utente di supporto sul problema in lavorazione.",
      viewChat: 'Chat',
      cannotAddSelf: 'Non puoi aggiungere te stesso. Questo ti bloccherebbe fuori dal tuo account amministratore.',
    },

    integrationMatter: {
      loadingState: 'Caricamento dati Matter...',
      settingsTab: 'Impostazioni',
      nodesTab: 'Nodi',
      devicesTab: 'Dispositivi',
      logsTab: 'Log',
      errorMessage: 'Connessione alla rete Matter fallita',
    },

    integrationMatterBridge: {
      brideDeviceCount: 'Dispositivi pontati',
      loadingState: 'Caricamento dati Matter Bridge...',
      bridgedDevicesTab: 'Dispositivi pontati',
      commissioningTab: 'Commissionamento',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      errorMessage: 'Connessione a Matter Bridge fallita',
    },

    integrationComputers: {
      subtitle: `Computer con l'agente ${brand.agentName}, associati a questo hub.`,
      integrationLabel: `Computer ${brand.platformCompact}`,
      refreshAction: 'Aggiorna',
      addComputerAction: 'Aggiungi computer',
      totalLabel: 'Computer',
      onlineLabel: 'Online',
      offlineLabel: 'Offline',
      onlineState: 'Online',
      offlineState: 'Offline',
      connectedState: 'Connesso',
      noComputersState: 'Attivato, nessun computer',
      disabledState: 'Disattivato',
      unknownState: 'Sconosciuto',
      loadingState: 'Caricamento computer…',
      emptyTitle: 'Nessun computer ancora',
      emptyMessage: `Installa l'agente ${brand.agentName} su un computer e associalo a questo hub per controllarlo da ${brand.platformName}.`,
      hostLabel: 'Host',
      platformLabel: 'Piattaforma',
      agentVersionLabel: 'Agente',
      lastSeenLabel: 'Ultima visualizzazione',
      neverSeen: 'mai',
      memoryLabel: 'Memoria',
      diskLabel: 'Disco',
      tempLabel: 'Temperatura CPU',
      uptimeLabel: 'Tempo di attività',
      rebootAction: 'Riavvia',
      sleepAction: 'Sospendi',
      shutdownAction: 'Spegni',
      wakeAction: 'Sveglia',
      wakeSendAction: 'Invia pacchetto di risveglio',
      wakeHint:
        "L'hub invia il pacchetto di risveglio dalla propria rete (WOL deve essere attivato nel BIOS del computer).",
      removeAction: 'Rimuovi',
      refreshNodeAction: 'Aggiorna stato',
      macPlaceholder: 'AA:BB:CC:DD:EE:FF',
      loadError: 'Impossibile caricare i computer',
      refreshFailed: 'Aggiornamento non riuscito',
      powerSent: 'Comando di alimentazione inviato a',
      powerFailed: 'Comando di alimentazione non riuscito',
      wakeSent: 'Pacchetto di risveglio inviato',
      wakeFailed: 'Wake-on-LAN non riuscito',
      removeConfirmTitle: 'Rimuovere il computer?',
      removeConfirmMessage: 'Questo scollega il computer da questo hub e rimuove il suo dispositivo.',
      removed: 'Computer rimosso',
      removeFailed: 'Rimozione non riuscita',
      addDialogTitle: 'Aggiungi computer',
      addDialogSubtitle: `Genera un codice di associazione, poi installa l'agente ${brand.agentName} sul computer con questo codice. Il codice scade dopo 15 minuti.`,
      nodeNamePlaceholder: 'es. PC studio',
      generateTokenAction: 'Genera codice di associazione',
      copyTokenAction: 'Copia',
      pairingCodeLabel: 'Codice di associazione',
      installCommandTitle: 'Sul computer, esegui:',
      doneAction: 'Fatto',
      copied: 'Codice di associazione copiato',
      copyFailed: 'Copia non riuscita',
      pairingFailed: 'Impossibile generare il codice di associazione',
      macLabel: 'MAC',
      hubAddressLabel: 'Indirizzo hub',
      hubAddressHint:
        "L'indirizzo che i computer useranno per raggiungere questo hub. La lista mostra gli indirizzi di rete di questo hub — scegli quello che il computer può raggiungere (ad es. la stessa rete), oppure inserisci un indirizzo personalizzato. In produzione (https) l'indirizzo dell'hub è preselezionato.",
      commandCopied: 'Comando copiato',
      computersTab: 'Computer',
      devicesTab: 'Dispositivi',
      customHubAddressAction: 'Indirizzo personalizzato...',
      customHubAddressPlaceholder: 'http://192.168.1.72',
      selectHubAddressHint: 'Scegli un indirizzo hub qui sopra per vedere i comandi di installazione.',
    },
    integrationTouchPanels: {
      integrationName: 'Touch Panel',
      statusDisabled: 'Disattivato',
      statusConnected: 'Connesso',
      statusReady: 'Pronto',
      loadingState: 'Caricamento integrazione Touch Panel...',
      panelsTab: 'Pannelli',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      refreshAction: 'Aggiorna',
      panelsAction: 'Pannelli',
      settingsAction: 'Impostazioni',
      logsAction: 'Log',
      totalPanelsLabel: 'Pannelli registrati',
      onlinePanelsLabel: 'Online ora',
      offlinePanelsLabel: 'Offline',
      sleepingPanelsLabel: 'In sospensione',
      pairingStatusLabel: 'Stato abbinamento',
      pairedPanelsLabel: 'Abbinati',
      pendingPanelsLabel: 'Abbinamento in sospeso',
      lastActivityLabel: 'Attività più recente',
      noActivityLabel: 'Nessuna attività recente',
      noActivityDescription: 'Nessun pannello ha ancora segnalato attività',
      attentionLabel: 'Richiede attenzione',
      justNowLabel: 'proprio ora',
      minutesAgoLabel: '{count} min fa',
      hoursAgoLabel: '{count} h fa',
      daysAgoLabel: '{count} g fa',
      errorMessage: 'Caricamento integrazione Touch Panel fallito',
    },

    integrationZigbee: {
      loadingState: 'Caricamento dati Zigbee...',
      nodesTab: 'Nodi',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      errorMessage: 'Connessione alla rete Zigbee fallita',
    },

    integrationZWave: {
      loadingState: 'Caricamento dati Z-Wave...',
      nodesTab: 'Nodi',
      networkTab: 'Rete',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      errorMessage: 'Connessione alla rete Z-Wave fallita',
    },
    integrationWled: {
      segmentsTab: 'Segmenti',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      loadingState: 'Caricamento...',
      errorMessage: 'Caricamento integrazione fallito',
    },

    integrationHue: {
      lightsTab: 'Luci',
      groupsTab: 'Gruppi',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
    },
    integrationUnifi: {
      networkTab: 'Rete',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
    },
    integrationSomfy: {
      gatewayTab: 'Gateway',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
    },
    integrationSynology: {
      statusTab: 'Stato',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
    },
    integrationMediaPlayers: {
      playersTab: 'Lettori',
      devicesTab: 'Dispositivi',
      sourcesTab: 'Sorgenti',
      settingsTab: 'Impostazioni',
    },
    integrationSonos: {
      settingsTab: 'Impostazioni',
      playersTab: 'Lettori',
      devicesTab: 'Dispositivi',
    },
    integrationSpotify: {
      settingsTab: 'Impostazioni',
      devicesTab: 'Dispositivi',
    },

    panelPairing: {
      title: `${brand.agentName} Pannello Touch`,
      subtitle: 'Configurazione dispositivo',
      discoverTitle: `Trova il tuo hub ${brand.agentName}`,
      discoverDescription: `Ricerca della tua rete locale per un hub ${brand.agentName}...`,
      scanningStatus: 'Scansione rete...',
      noHubsFound: 'Nessun hub trovato automaticamente.',
      manualEntryHint: "Inserisci manualmente l'indirizzo dell'hub qui sotto.",
      manualEntryLabel: 'O inserisci manualmente',
      ipAddressPlaceholder: 'Indirizzo IP hub',
      portPlaceholder: 'Porta',
      connectButton: 'Connetti',
      rescanButton: '↻ Scansiona di nuovo',
      backButton: 'Indietro',
      connectedToLabel: 'Connesso a',
      pairingMethodTitle: 'Associa questo dispositivo',
      pairingRequirement: `Un amministratore deve generare un codice di associazione nell'app ${brand.agentName}.`,
      enterPinButton: 'Inserisci PIN',
      pinEntryTitle: 'Inserisci PIN associazione',
      pinEntryDescription: `Inserisci il PIN a 6 cifre mostrato nell'app di amministrazione ${brand.agentName}.`,
      pairDeviceButton: 'Associa dispositivo',
      pairingInProgress: 'Associazione...',
      invalidPinError: 'PIN non valido. Riprova.',
      cameraAccessDenied: 'Accesso alla fotocamera negato. Abilita i permessi della fotocamera.',
      invalidQrError: 'Codice QR non valido. Riprova.',
      exitPinTitle: 'Imposta PIN di uscita',
      exitPinDescription: 'Scegli un PIN a 4 cifre per uscire dalla modalità pannello più tardi.',
      skipButton: 'Salta',
      pairedSuccess: 'Dispositivo associato!',
      connectingMessage: 'Connessione al tuo pannello...',
    },

    playPairing: {
      title: `${brand.agentName} Play`,
      subtitle: 'Configurazione dispositivo',
      discoverTitle: `Trova il tuo hub ${brand.agentName}`,
      discoverDescription: `Ricerca della tua rete locale per un hub ${brand.agentName}...`,
      scanningStatus: 'Scansione rete...',
      noHubsFound: 'Nessun hub trovato automaticamente.',
      manualEntryHint: "Inserisci manualmente l'indirizzo dell'hub qui sotto.",
      manualEntryLabel: 'O inserisci manualmente',
      ipAddressPlaceholder: 'Indirizzo IP hub',
      portPlaceholder: 'Porta',
      connectButton: 'Connetti',
      rescanButton: '↻ Scansiona di nuovo',
      backButton: 'Indietro',
      connectedToLabel: 'Connesso a',
      pairingMethodTitle: 'Associa questo dispositivo',
      pairingRequirement: `Un amministratore deve generare un codice di associazione nell'app ${brand.agentName}.`,
      enterPinOption: 'Inserisci PIN',
      enterPinDescription: "Inserisci il codice a 6 cifre mostrato nell'app di amministrazione",
      scanQrOption: 'Scansiona codice QR',
      scanQrDescription: "Scansiona il codice QR mostrato nell'app di amministrazione",
      pinEntryTitle: 'Inserisci PIN associazione',
      pinEntryDescription: `Inserisci il PIN a 6 cifre mostrato nell'app di amministrazione ${brand.agentName}.`,
      pairDeviceButton: 'Associa dispositivo',
      pairingInProgress: 'Associazione...',
      scanQrTitle: 'Scansiona codice QR',
      scanQrInstruction: `Inquadra il codice QR nell'app di amministrazione ${brand.agentName} con la fotocamera.`,
      scanningAutoStatus: 'Scansione automatica...',
      exitPinTitle: 'Imposta PIN di uscita',
      exitPinDescription: 'Scegli un PIN a 4 cifre per uscire dalla modalità Play più tardi.',
      confirmPinButton: 'Conferma PIN',
      reenterPinInstruction: 'Reinserisci il tuo PIN per confermare',
      pinMismatchError: 'I PIN non corrispondono. Riprova.',
      skipButton: 'Salta',
      pairedSuccess: 'Dispositivo associato!',
      pairedDescription: `Questo dispositivo è ora collegato al tuo hub ${brand.agentName} come dispositivo Play.`,
      startPlayModeButton: 'Avvia modalità Play',
      invalidPinError: 'PIN non valido. Riprova.',
      cameraAccessDenied: 'Accesso alla fotocamera negato. Abilita i permessi della fotocamera.',
      invalidQrError: 'Codice QR non valido. Riprova.',
    },

    gallery: {
      pageTitle: 'Foto',
      emptyTitle: 'Nessuna foto ancora',
      emptyDescription: 'Carica foto e video per iniziare la tua galleria personale nel cloud.',
      noAlbumTitle: 'Nessun album ancora',
      noAlbumDescription: 'Crea un album per raggruppare e condividere le tue foto.',
      noAlbumItems: 'Nessuna foto in questo album ancora',
      newAlbum: 'Nuovo album',
      takePhoto: 'Fotocamera',
      uploadPhotos: 'Carica',
      createAlbumTitle: 'Crea album',
      selectPhotos: 'Seleziona',
      uploadProgress: 'Caricamento',
      dropZoneText: 'Trascina foto e video qui',
      uploadStatus: 'file',
      uploadStatusPlural: 'file',
      sharedBadge: 'Condiviso',
      publicBadge: 'Pubblico',
    },

    reminders: {
      pageTitle: 'Promemoria',
      addButton: 'Nuovo promemoria',
      upcomingTab: 'Prossimi',
      completedTab: 'Completati',
      emptyUpcoming: 'Nessun promemoria prossimo.',
      emptyCompleted: 'Nessun promemoria completato.',
      createReminderTitle: 'Nuovo promemoria',
      editReminderTitle: 'Modifica promemoria',
      titleLabel: 'Titolo',
      titlePlaceholder: 'Compra la spesa',
      notesLabel: 'Note',
      notesPlaceholder: 'Dettagli aggiuntivi...',
      notesOptional: '(opzionale)',
      dateTimeLabel: 'Data e ora',
      repeatLabel: 'Ripeti',
      repeatNone: 'Mai',
      repeatDaily: 'Giornaliero',
      repeatWeekly: 'Settimanale',
      repeatMonthly: 'Mensile',
      repeatWeekdays: 'Giorni feriali (Lun–Ven)',
      cancelButton: 'Annulla',
      saveButton: 'Salva',
      createButton: 'Crea promemoria',
    },

    timers: {
      pageTitle: 'Timer',
      addButton: 'Nuovo timer',
      emptyState: 'Nessun timer ancora. Tocca Nuovo timer per crearne uno.',
      createTimerTitle: 'Nuovo timer',
      labelLabel: 'Etichetta',
      labelPlaceholder: 'Acqua per la pasta',
      durationLabel: 'Durata',
      hoursLabel: 'Ore',
      minutesLabel: 'Minuti',
      secondsLabel: 'Secondi',
      soundLabel: 'Suono',
      totalLabel: 'totale',
      startButton: 'Avvia',
      pauseButton: 'Pausa',
      resetButton: 'Reimposta',
      deleteButton: 'Elimina',
      deleteConfirm: 'Eliminare questo timer?',
      cancelButton: 'Annulla',
      createButton: 'Crea',
      creatingLabel: 'Creazione...',
      statusIdle: 'inattivo',
      statusRunning: 'in corso',
      statusPaused: 'in pausa',
      statusCompleted: 'completato',
    },
    integrationESPHome: {
      entitiesTab: 'Nodi ed entità',
      devicesTab: 'Dispositivi',
      settingsTab: 'Impostazioni',
      logsTab: 'Log',
      loadingState: 'Caricamento dati ESPHome...',
      errorMessage: 'Caricamento integrazione ESPHome fallito',
    },
    integrationTorik: {
      entitiesTab: 'Importa',
      devicesTab: 'Dispositivi',
      settingsTab: 'Collegamento',
      logsTab: 'Log',
      loadingState: 'Caricamento collegamento hub Torik...',
      entitiesTitle: 'Dispositivi remoti',
      entitiesHint:
        "Scopri i dispositivi sull'hub collegato e importali come dispositivi locali. I valori restano sincronizzati e i comandi vengono inoltrati.",
      discover: 'Scopri dispositivi',
      discovering: 'Ricerca...',
      searchPlaceholder: 'Cerca per nome o ID entità...',
      selectAll: 'Seleziona tutto',
      selected: 'selezionati',
      importCount: 'Importa',
      imported: 'Importati',
      emptyState: "Premi Scopri dispositivi per recuperare i dispositivi dall'hub collegato.",
      importTitle: 'Importa dispositivi remoti',
      roomMapping: 'Mappa le stanze remote sulle stanze locali:',
      remoteRoom: 'Stanza remota:',
      noRoom: '— Nessuna stanza (abbinamento automatico per nome) —',
      created: 'Creati',
      skipped: 'Saltati',
      errors: 'Errori',
      close: 'Chiudi',
      cancel: 'Annulla',
      import: 'Importa',
      importing: 'Importazione...',
      linkTitle: 'Collegamento hub',
      linkHint: "Connessione all'hub Torik collegato (la sua API Torik).",
      test: 'Testa connessione',
      testing: 'Test in corso...',
      sync: 'Sincronizza ora',
      syncing: 'Sincronizzazione...',
      syncDone: 'Sincronizzazione completata',
      reconnect: 'Riconnetti',
      reconnecting: 'Riconnessione...',
      reconnectDone: 'Riconnesso',
      cleanup: 'Rimuovi tutti i dispositivi importati',
      cleaning: 'Rimozione...',
      cleanupConfirm: 'Rimuovere tutti i dispositivi importati da questo hub? Questa azione non può essere annullata.',
      cleanupDone: 'Dispositivi rimossi',
      peerUrl: 'URL peer',
      peerVersion: 'Versione peer',
      token: 'Token di accesso',
    },
    // The guest experience of the demo house (card `t_803e86a4`) — see `en.ts`.
    demoGuest: {
      pill: 'Ospite',
      pillNamed: 'Ospite · {name}',
      hint: 'Questa è una casa demo — un’intera giornata viene simulata in pochi minuti.',
      dismiss: 'Nascondi',
    },
  },
  shell: {
    home: 'Home',
    // The floor for a tab nothing else names (card t_99f5ed79) — see `en.ts`.
    newTab: 'Nuova scheda',
    closeTab: 'Chiudi scheda',
    alertError: 'Errore',
    alertWarning: 'Avviso',
    alertNotice: 'Segnalazione',
    player: 'Lettore',
    previous: 'Precedente',
    play: 'Riproduci',
    pause: 'Pausa',
    mute: 'Muto',
    unmute: 'Riattiva audio',
    volume: 'Volume',
    // The main process's native popups (card t_99f5ed79): the tab context menu,
    // the app menu, and the connection-info dialog — see `en.ts` for the note.
    openInNewWindow: 'Apri in una nuova finestra',
    connectionInfo: 'Informazioni sulla connessione',
    reload: 'Ricarica',
    fullscreen: 'Schermo intero',
    close: 'Chiudi',
    launcher: 'Launcher',
    services: 'Servizi',
    miniPlayerWindow: 'Finestra del mini lettore',
    rebuildBar: 'Ricostruisci la barra di sistema',
    settings: 'Impostazioni',
    quit: 'Esci',
    info: {
      target: 'Destinazione',
      endpoint: 'Endpoint',
      hubId: 'ID hub',
      hubName: 'Nome hub',
      state: 'Stato',
      route: 'Percorso',
      connected: 'connesso',
      disconnected: 'non connesso',
      secure: 'sicuro',
      cloudHub: 'hub nel cloud {id}',
      managedInLauncher: 'Le credenziali e i server salvati si gestiscono nel launcher.',
      ok: 'OK',
      tab: 'Scheda',
    },
  },
  connectionLost: {
    title: 'Connessione persa',
    session: '{hub}: la sessione è scaduta. Riconnettiti per continuare a lavorare in questa scheda.',
    offline: '{hub} non risponde. Controlla la rete, poi riconnettiti.',
    thisServer: 'Questo server',
    reconnect: 'Riconnetti',
    reconnecting: 'Riconnessione...',
    close: 'Chiudi',
  },
  api: {
    // What a failed hub call actually means (`utils/apiFailure.ts`), so a surface
    // that only catches the error can still name the cause instead of one sentence
    // that fits every failure — read as `t(apiFailureSentenceKey(error))`.
    failure: {
      unreachable: 'Non è stato possibile raggiungere l’hub, quindi queste impostazioni non sono state lette.',
      refused: 'Questa finestra non ha effettuato l’accesso all’hub, che ha quindi rifiutato queste impostazioni.',
      wrong_target:
        'La risposta non proviene dal servizio di questo hub, quindi queste impostazioni non sono state lette.',
      hub_failed: 'L’hub ha segnalato un errore durante la lettura di queste impostazioni.',
    },
  },
  hub: {
    // Adopting an unclaimed hub from the app (HEADLESS-HUB-ONBOARDING.md
    // D3/D4/D5): the confirm sheet, the sticker QR and every refusal the hub
    // can answer with — one sentence each, in every shipped locale.
    adopt: {
      title: 'Adotta questo hub',
      intro:
        'Questo hub è sulla tua rete e non ha ancora un proprietario. Adottandolo viene registrato nel tuo account Torik e diventi il suo proprietario.',
      notOffered:
        'Questo hub non è in attesa di adozione, quindi qui non c’è nulla da adottare. Non è stato inviato nulla — se il tuo account Torik è su questo hub, aprilo dai tuoi server.',
      hubLabel: 'Hub',
      accountLabel: 'Account',
      roleLabel: 'Il tuo ruolo',
      roleOwner: 'Proprietario',
      noCode: 'Non c’è nulla da digitare: il tuo account è la credenziale.',
      noAccount: 'Non connesso',
      // Una sessione di cui questo foglio non conosce il nome dell’account: il
      // dispositivo È connesso, e la riga non può dire il contrario (card t_a53c5f61).
      accountSignedIn: 'Connesso',
      signInRequired: 'Accedi al tuo account Torik per adottare questo hub.',
      signIn: 'Accedi',
      signingIn: 'Apertura…',
      signInFailed: 'Non è stato possibile avviare l’accesso. Riprova.',
      confirm: 'Adotta questo hub',
      working: 'Adozione…',
      retry: 'Riprova',
      cancel: 'Annulla',
      doneTitle: '{hub} è tuo',
      doneBody: 'È registrato sotto {account} e questo dispositivo è ora associato a esso.',
      // La variante della frase sopra senza nome dell’account: `{account}` non può
      // portare una frase in ogni lingua, quindi questo caso si riformula.
      doneBodySignedIn: 'È registrato sotto il tuo account Torik e questo dispositivo è ora associato a esso.',
      doneWhere: 'Lo troverai nei tuoi server, nella pagina iniziale.',
      roleLine: 'Hai il ruolo {role} su questo hub.',
      continue: 'Continua',
      scanLead: 'Hub appena acquistato? Scansiona il codice stampato sulla confezione: lo adotti nel tuo account.',
      linkWrongHub:
        'Questo codice appartiene a un hub diverso da quello che risponde a questo indirizzo. Non è stato adottato nulla.',
      linkUnverified:
        'L’hub a questo indirizzo non ha confermato quale hub sia, quindi non è stato adottato nulla. Verifica che l’hub sia acceso e raggiungibile.',
      rateLimited: 'Troppi tentativi da questo dispositivo. Attendi un minuto e riprova.',
      notOnHubNetwork:
        'L’hub ha rifiutato: questo dispositivo non è sulla rete dell’hub. Collegati alla stessa rete dell’hub (non via VPN) e riprova.',
      alreadyClaimed: 'Questo hub ha già un proprietario. Chiedigli di invitarti.',
      invalidCloudToken: 'La sessione del tuo account Torik è stata rifiutata. Accedi di nuovo, poi adotta.',
      invalidDevice: 'L’hub ha rifiutato la chiave di questo dispositivo. Riprova.',
      cloudUnreachable:
        'L’hub non ha potuto raggiungere il cloud Torik, quindi non si è registrato. Controlla la connessione internet dell’hub e riprova.',
      hubIdentityUnavailable: 'L’hub non riesce ancora a leggere la propria identità. Attendi un momento e riprova.',
      registrationFailed: 'Il cloud ha rifiutato di registrare l’hub nel tuo account. Riprova o contatta l’assistenza.',
      unsupported: 'Questo hub non supporta l’adozione (software più vecchio).',
      unreachable: 'Nessuno ha risposto a questo indirizzo. Verifica che l’hub sia acceso e su questa rete.',
      unproven:
        'Il dispositivo a questo indirizzo non ha potuto dimostrare di essere questo hub. Non è stato adottato nulla e il tuo account non gli è stato inviato.',
      malformed: 'L’hub ha risposto senza adozione. Non è stato modificato nulla.',
      refused: 'L’hub ha rifiutato l’adozione.',
      cardAction: 'Hub senza proprietario — adottarlo?',
      cardHint:
        'Nessuno possiede ancora {hub}. Adottandolo viene registrato nel tuo account Torik e diventi il suo proprietario.',
      cardSignIn: 'Accedi al tuo account Torik per adottare {hub}.',
      badgeWaiting: 'In attesa di adozione',
      localPageHint: '{hub} non ha ancora un proprietario: trovalo con la ricerca dei server locali.',
      localPageAction: 'Cerca server locali',
      addressLabel: 'Indirizzo',
      loopbackOnly:
        'Questo dispositivo può raggiungere questo hub solo su {address} — la sua stessa macchina. Un hub non accetta mai un’adozione da se stesso (da lì arrivano anche le chiamate in tunnel), quindi adottalo da un altro dispositivo sulla stessa rete.',
      tokenRetired:
        'L’hub non accetta più l’accesso con un account per l’adozione — serve una licenza. Aggiorna l’app e riprova.',
      licenceUsed:
        'Quella licenza di adozione è già stata usata. Non è cambiato nulla — riprova per ottenerne una nuova.',
      licenceExpired: 'La licenza di adozione è scaduta prima che l’hub potesse usarla. Riprova.',
      licenceMismatch: 'Quella licenza è stata emessa per un altro hub. Non è stato adottato nulla.',
      licenceInvalid:
        'L’hub non ha potuto verificare la licenza firmata dal cloud. Aggiorna l’app e l’hub, poi riprova.',
      licenceRequired:
        'L’hub si aspettava una licenza di adozione e non ne è stata inviata nessuna. Aggiorna l’app e riprova.',
      licenceRefused: 'Il cloud ha rifiutato di emettere una licenza di adozione per questo hub.',
      licenceUnknownHub:
        'Il cloud non ha potuto identificare questo hub, quindi non ha emesso alcuna licenza. Lascia che l’hub raggiunga internet una volta, poi riprova.',
      licenceAlreadyOwned: 'Un altro account Torik possiede già questo hub. Chiedi al proprietario di invitarti.',
      licenceUnavailable:
        'Il cloud al momento non può emettere licenze di adozione. Riprova più tardi o contatta l’assistenza.',
      licenceUnauthorized: 'La sessione del tuo account Torik è stata rifiutata. Accedi di nuovo, poi adotta.',
      licenceUnreachable:
        'Non è stato possibile raggiungere il cloud Torik, quindi non è stata emessa alcuna licenza. Controlla la connessione internet di questo dispositivo e riprova.',
      licenceMalformed: 'Il cloud ha risposto senza licenza. Non è stato adottato nulla — riprova.',
      password: {
        title: 'Imposta una password locale',
        intro:
          'Una password per {hub} tiene in funzione questa casa anche senza internet — e permette a chiunque in casa di accedere anche quando il cloud Torik non è raggiungibile.',
        label: 'Password',
        hint: 'Almeno 8 caratteri.',
        confirmLabel: 'Conferma la password',
        mismatch: 'Le due password non coincidono.',
        currentLabel: 'Password attuale',
        save: 'Salva password',
        saving: 'Salvataggio…',
        skip: 'Non ora',
        done: 'Password locale salvata — questa casa ora funziona anche senza internet.',
        noSessionNote:
          'Questo dispositivo non ha effettuato l’accesso all’hub, quindi non è stato possibile impostare una password locale. Apri l’hub e impostala lì.',
        resolving: 'Verifica di questo server…',
        noAddress:
          'Questo server non ha un indirizzo che questo dispositivo possa chiamare, quindi da qui non si può impostare una password locale.',
        noAccount: 'Accedi al tuo account Torik per impostare una password locale su questo hub.',
        notThisAccount:
          'Questo hub appartiene a un altro account Torik, quindi questo account non può impostarne la password locale.',
        noAnswer:
          'Nessuno ha risposto all’indirizzo di questo hub, quindi non è stato possibile impostare una password locale. Controlla che l’hub sia acceso e su questa rete.',
        close: 'Chiudi',
        required: 'Inserisci una password.',
        tooShort: 'La password è troppo corta — almeno 8 caratteri.',
        tooLong: 'La password è troppo lunga (al massimo 72 byte).',
        wrongCurrent: 'Non è la password che questo account ha già sull’hub.',
        notPermitted: 'Solo un amministratore può impostare questa password.',
        noSuchUser: 'L’hub non conosce questo account.',
        noSession: 'Questo dispositivo non ha effettuato l’accesso all’hub, quindi non può impostare una password.',
        invalidCredentials: 'Nome utente o password errati.',
        disabled: 'Questo account è disabilitato su questo hub.',
        outsideWindow:
          'Questo account può accedere solo negli orari impostati sull’hub. Chiedi al proprietario dell’hub di spostare la finestra.',
        tooManyAttempts: 'Troppi tentativi. Attendi un minuto e riprova.',
        unreachable: 'Nessuno ha risposto a questo indirizzo. Verifica che l’hub sia acceso e su questa rete.',
        refused: 'L’hub ha rifiutato di impostare quella password.',
      },
    },
    join: {
      title: 'Unisciti a questo hub',
      intro:
        'Questo hub è sulla tua rete e il tuo account Torik ha già un ruolo su di esso. Unendoti, il tuo account viene collegato qui e questo dispositivo può usare l’hub — senza codice e senza password.',
      hubLabel: 'Hub',
      accountLabel: 'Account',
      roleLabel: 'Il tuo ruolo',
      roleReading: 'Verifica…',
      roleUnknown: 'Non ancora noto',
      noCode:
        'Niente da digitare — il tuo account è la credenziale. Il codice sullo schermo dell’hub è per ospiti, fornitori e pannelli senza tastiera.',
      noAccount: 'Non connesso',
      signInRequired: 'Accedi al tuo account Torik per unirti a questo hub.',
      confirm: 'Unisciti a questo hub',
      working: 'Unione…',
      retry: 'Riprova',
      cancel: 'Annulla',
      doneTitle: 'Ti sei unito a {hub}',
      doneBody: '{account} è ora collegato a questo hub e questo dispositivo può usarlo.',
      roleLine: 'Il tuo ruolo su questo hub è {role}.',
      continue: 'Continua',
      noMatchingUser:
        'Questo hub non ha ancora un utente con il tuo indirizzo e-mail. Chiedi al proprietario dell’hub di invitare questo indirizzo, poi riprova.',
      notAMember:
        'Il tuo account Torik non ha alcun ruolo su questo hub. Chiedi al proprietario dell’hub di invitare questo indirizzo.',
      userDisabled: 'Questo account è disattivato su questo hub. Chiedi al proprietario dell’hub di attivarlo.',
      outsideLoginWindow:
        'Questo account può accedere solo negli orari impostati sull’hub. Chiedi al proprietario dell’hub di spostare la finestra.',
      invalidCloudToken: 'La sessione del tuo account Torik è stata rifiutata. Accedi di nuovo e riprova.',
      deviceInUse:
        'Questo dispositivo è già registrato con un altro account. Revocalo prima lì oppure usa un altro dispositivo.',
      alreadyClaimed: 'Questo hub ha appena preso questo dispositivo — la richiesta era già stata usata. Riapri l’hub.',
      expired: 'La richiesta è scaduta prima che l’hub la prendesse. Riprova.',
      grantKeyMissing:
        'Il cloud Torik non può firmare l’autorizzazione per questo dispositivo in questo momento. Riprova tra un istante.',
      unknownDevice: 'L’hub non conosce questa registrazione. Riprova.',
      notApproved: 'L’hub non ha ancora registrato l’autorizzazione per questo dispositivo. Riprova tra un istante.',
      invalidProof: 'L’hub ha rifiutato la chiave di questo dispositivo. Riprova.',
      rateLimited: 'Troppi tentativi da questo dispositivo. Attendi un minuto e riprova.',
      unreachable: 'Nessuna risposta a questo indirizzo. Verifica che l’hub sia acceso e su questa rete.',
      malformed: 'L’hub ha risposto senza collegare questo dispositivo. Non è stato modificato nulla.',
      refused: 'L’hub ha rifiutato la richiesta. Non è stato modificato nulla.',
    },

    // Un hub che questa app non riesce ad aprire (card `t_bfe0edc9`): la frase che dice di chi

    // credenziale mancante e dove si trova il suo modo di entrare (utils/hubOpenFallback.ts).

    open: {
      title: 'Impossibile aprire {hub}',

      dismiss: 'Chiudi',

      openLocalPage: 'Cerca server locali',

      openServers: 'Server',

      needsCredential:
        'Le pagine di questo hub richiedono una credenziale che questo dispositivo non ha. Non è stato inviato né modificato nulla.',

      // Una frase per ogni modo in cui un hub resta chiuso (`HUB_OPEN_FAILURES`).

      failure: {
        no_credential:
          'Questo dispositivo non ha ancora una credenziale per {hub}. Il tuo account Torik lo apre da qui — senza codice e senza password.',

        credential_refused:
          '{hub} non ha accettato la credenziale di questo dispositivo, quindi è stata scartata. Aprilo da qui con il tuo account Torik — non serve alcun codice.',

        no_cloud_session: 'Accedi al tuo account Torik per aprire {hub}.',

        no_lan_address: '{hub} non ha annunciato alcun indirizzo che questo dispositivo possa contattare.',

        no_account_identity:
          'Il tuo account Torik non conosce ancora {hub}. Adottalo qui, oppure chiedi al suo proprietario di invitare questo indirizzo.',

        unreachable: 'Nessuno ha risposto su {address}. Verifica che {hub} sia acceso e su questa rete.',
        permission_held:
          'Il browser sta trattenendo questa richiesta: questo sito non è ancora autorizzato ad accedere alla tua rete locale. Consenti l’accesso alla rete locale e riprova, oppure apri {hub} tramite il cloud.',

        not_this_hub: 'Qualcosa ha risposto su {address}, e non è {hub}.',

        not_proven:
          '{hub} ha risposto su {address} e non ha potuto dimostrare di possedere la chiave fissata dal tuo account. Non è stato inviato nulla.',

        cannot_prove: 'Non è stato possibile chiedere al dispositivo su {address} se è {hub}.',

        refused:
          '{hub} ha rifiutato la richiesta del tuo account Torik — chiedi al suo proprietario di invitare questo indirizzo.',

        // Il rifiuto proprio del **cloud** (`services/cloudSessionRefusal.ts`,
        // plan FLOOR-PLAN-AND-PLAN-EDITOR.md §3.2/D3): il server è solo locale.
        // Non un errore — il suo stato, detto una volta.
        remote_access_not_licensed:
          'Questo server è impostato su solo accesso locale — puoi raggiungerlo dalla sua stessa rete. L’accesso remoto è incluso in un piano server a pagamento.',
      },
    },
    // L’**installazione** (piano `LOCAL-SERVER-ONBOARDING-JOURNEY.md` §3/C2–C3,
    // decisioni del proprietario §7 Q1/Q2/Q4): cosa apre la pagina Locale per un
    // server che appartiene a questo account e il cui piano lo tiene sulla sua
    // rete. Prima lo stato, poi la frase onesta sul piano a pagamento e infine la
    // password locale (`hub.adopt.password.*` — il passo condiviso con
    // l’adozione). Qui non si vende nulla: nessun listino e nessun acquisto, il
    // piano vive nell’account.
    onboard: {
      title: 'Configura questo server',
      intro:
        'Questo server lavora sulla tua rete. Qui trovi lo stato della licenza e la password che lo mantiene raggiungibile anche senza internet.',
      licenceLabel: 'Licenza',
      reading: 'Lettura…',
      remoteTitle: 'L’accesso remoto richiede un piano a pagamento',
      remoteBody:
        'L’accesso remoto a questo server fa parte di un piano a pagamento. Gestisci il piano nel tuo account Torik.',
      accountLink: 'Gestisci il piano nel tuo account',
      accountHint: 'Apre il tuo account Torik nel browser.',
      openButton: 'Configura {hub}',
      doneTitle: '{hub} è configurato',
      doneSkipped: 'Fatto. Puoi impostare la password locale in qualsiasi momento da questa pagina.',
      noAddress:
        'Questo server non ha annunciato nessun indirizzo raggiungibile da questo dispositivo, quindi la password locale non può essere impostata da qui. Aprilo prima dai tuoi server.',
    },
  },
  // WLED integration — the two tabs read these (WLEDSegmentsTab.vue, WLEDSettingsTab.vue)
  wled: {
    tabs: {
      segmentsTitle: 'Segmenti',
      segmentsSubtitle:
        'Ogni segmento WLED attivo può essere importato come dispositivo luce (effetti, palette e preset inclusi).',
    },
    discover: 'Rileva',
    discovering: 'Rilevamento...',
    creating: 'Creazione...',
    createDevices: 'Crea dispositivi luce',
    loading: 'Caricamento segmenti...',
    emptyTitle: 'Nessun segmento trovato',
    emptyMessage:
      'Premi Rileva per leggere la disposizione dei segmenti dal controller WLED. I dispositivi vengono creati per segmento: un controller standard con una sola striscia ha un segmento che copre tutti i LED.',
    createHint: 'Crea un dispositivo luce per segmento (predefinito: tutti).',
    loadFailed: 'Impossibile caricare i segmenti',
    createFailed: 'Impossibile creare i dispositivi',
    discoveryFailed: 'Rilevamento non riuscito',
    alreadyImported: 'I segmenti già importati sono stati ignorati. Le nuove luci compaiono in Stanze / Dispositivi.',
    colName: 'Segmento',
    colType: 'Tipo',
    colColor: 'Colore',
    colEffect: 'Effetto',
    colPalette: 'Palette',
    colStatus: 'Stato',
    online: 'Online',
    offline: 'Offline',
    settings: {
      title: 'Impostazioni',
      subtitle: 'Impostazioni di connessione per il controller WLED. Un’integrazione gestisce un controller.',
      connected: 'Connessa',
      disconnected: 'Disconnessa',
      noUrl: 'Nessun URL del controller configurato',
      enabled: 'Attivato',
      disabled: 'Disattivata',
      reconnecting: 'Riconnessione...',
      reconnect: 'Riconnetti',
      boardTitle: 'Controller',
      refresh: 'Aggiorna',
      name: 'Nome',
      version: 'Firmware',
      leds: 'LED',
      channels: 'Canali',
      url: 'URL del controller',
      scanning: 'Scansione...',
      findOnNetwork: 'Trova in rete',
      urlHint: 'Indirizzo IP o nome host del controller WLED — oppure usa Trova in rete.',
      apiKey: 'Chiave API',
      apiKeyPlaceholder: 'Facoltativo',
      hide: 'Nascondi',
      show: 'Mostra',
      apiKeyHint: 'Necessaria solo se la sicurezza di WLED è attiva.',
      pollInterval: 'Intervallo di polling (secondi)',
      pollHint: 'Aggiornamento di riserva usato quando il WebSocket non è disponibile.',
      testing: 'Test in corso...',
      test: 'Prova connessione',
      saved: 'Impostazioni salvate.',
      saving: 'Salvataggio...',
      save: 'Salva impostazioni',
      errorUpdate: 'Impossibile aggiornare l’integrazione',
      errorReconnect: 'Riconnessione non riuscita',
      errorConnection: 'Connessione non riuscita',
      errorSave: 'Impossibile salvare le impostazioni',
    },
  },
} as const;
